import colombiacircle from "../assets/flags/colombiacircle.svg"
import usacircle from "../assets/flags/usacircle.svg"
import appstorees from "../assets/badges/appstorewhitees.svg"
import appstoreen from "../assets/badges/appstorewhiteen.svg"
import googleplayes from "../assets/badges/gplayes.png"
import googleplayen from "../assets/badges/gplayen.png"
import localConfig from "../local_config"
import brazilcircle from "../assets/flags/brazilcircle.png"

const common = {
    es: {
        any_question: "Conócenos",
        bring_crypto :"Trae tus criptos",
        one_card_all_crypto :"Todo tu mundo cripto, en una tarjeta",
        amount_too_high: "Monto demasiado alto",
        no_results_found: "Sin resultados",
        enter_amount: "Ingresa el monto",
        amount_exceeds_balance: "El monto excede el saldo disponible",
        type_search: "Escribe para buscar...",
        create_payment:"Añadir",
        amount_too_low:"Monto demasiado bajo",
        country_not_supported: "Pais no admitido",
        country_missing: "País no seleccionado",
        fee_note: "Nota: Los bancos pueden cobrar comisiones adicionales por transferencias.",
        fee_breakdown: "Desglose de comisiones",
        amount_to_receive: "Cantidad a recibir",
        fee_deducted: "Comisión deducida",
        fee_calculation: "Comisión",
        max_withdrawal:"Retiro máximo",
        min_withdrawal:"Retiro mínimo",
        invalid_value: "Valor invalido",
        limits_note: "Nota: Las comisiones ya están incluidas en los límites.",
        rates_are_referential: "*Las tarifas mostradas son solo referenciales",
        input_number_to_see_rates:"Ingresa un monto para ver la tasa de cambio",
        please_try_again: "Por favor intenta nuevamente",
        asset: "Activo",
        pan: "PAN",
        cvc: "CVC",
        occupation: "Ocupación",
        annualSalary: "Salario anual",
        accountPurpose: "Propósito de la cuenta",
        validating_kyc_data_title: "Estamos validando tu información",
        validating_kyc_data_text: `En unos momentos podrás entrar al mundo ${localConfig.brand}`,
        not_available: "No disponible",
        login_or_register_to_enter_raffle: "Ingresa o crea una cuenta para participar",
        success_registration_raffle: "Ya estas participando!",
        we_are: "Estamos en",
        maintenance: "mantenimiento",
        icon: colombiacircle,
        apple_download_badge: appstorees,
        google_download_badge: googleplayes,
        continue: "Continuar",
        description: "Descripción",
        login: "Iniciar sesión",
        logout: "Cerrar sesión",
        email: "Correo electrónico",
        password: "Contraseña",
        email_placeholder: "Ingrese su correo electrónico",
        password_placeholder: "Ingrese su contraseña",
        dont_have_account: "¿No tienes una cuenta?",
        forgot_password: "¿Olvidaste tu contraseña?",
        invalid_login: "Credenciales inválidas",
        reset_psw: "Debido a la actualización, es necesario restablecer su contraseña",
        confirm_password: "Confirmar contraseña",
        confirm_password_placeholder:"Ingrese su contraseña nuevamente",
        register: "Crear cuenta",
        register_success: "Creación de cuenta exitosa",
        register_fail: "Creación de cuenta fallida",
        already_have_account: "¿Ya tienes una cuenta?",
        password_mismatch: "Las contraseñas no coinciden",
        password_too_short: "Al menos 8 caracteres",
        password_needs_uppercase: "Al menos una letra mayúscula",
        password_needs_lowercase: "Al menos una letra minúscula",
        password_needs_number: "Al menos un número",
        password_needs_special: "Al menos un carácter especial",
        hinting_regex_error: "La contraseña no cumple con los requerimientos mínimos",
        complete_the_captcha: "Complete el CAPTCHA",
        register_failed: "Creación de cuenta fallida, intente nuevamente",
        balance_navbar: "Balance total",
        terms_text1: "He leído y estoy de acuerdo con los",
        terms_text2: "de Nemo Latam.",
        terms_and_conditions: "Términos y Condiciones",
        card_term1_texta: "Acepto el",
        card_term1_textb: "Consentimiento de Firma Electrónica",
        card_term2_texta: "Acepto los",
        card_term2_textb: "Términos de la Tarjeta Nemo",
        card_term2_textc: ", y la",
        card_term2_textd: "Política de Privacidad de Nemo",
        card_term3_texta: "Certifico que la información proporcionada es precisa y que cumpliré con todas las normas y requisitos relacionados con mi Tarjeta de Gastos Nemo.",
        card_term4_texta: "Reconozco que solicitar la Tarjeta de Gastos Nemo no constituye una solicitud no autorizada.",
        privacy_policy: "Política de Privacidad",
        data_processing_policy: "Política de Tratamiento de Datos",
        declaration_text1: "He leído y confirmo la",
        goods_declaration: "Declaración Jurada de Origen de Fondos.",
        authorization_text1: "He leído y confirmo la",
        data_authorization: "Autorización para el tratamiento",
        authorization_text2: "de mis datos personales.",
        confirm_email: "Confirmar correo",
        email_code: "Código de confirmación",
        email_code_text: "Se te ha enviado un correo electrónico con un código, por favor ingréselo a continuación.",
        confirm: "Confirmar",
        cancel: "Cancelar",
        code_placeholder: "Ingrese su código de confirmación",
        resent_code: "Código reenviado",
        email_confirmed: "Correo verificado. Inicia sesión para verificar tu identidad",
        verify_email: "Verificar correo",
        back_to_login: "Volver a inicio de sesión",
        resend_code: "Reenviar codigo",
        in: "en",
        name: "Nombre",
        seconds: "segundos",
        click_to: "Clic para",
        click_here: "Clic aquí",
        incorrect_code: "Código erroneo",
        reset_password: "Restablecer contraseña",
        email_sent: "Correo enviado",
        error: "Error",
        unexpected_error: "Ocurrió un error inesperado",
        invalid_confirmation_code: "Código de confirmación inválido",
        captcha_failed: "Captcha fallido",
        reset_continue_text: "Te hemos enviado un correo con instrucciones sobre cómo proceder con el reinicio de tu contraseña.",
        password_reset_success: "Contraseña actualizada existosamente",
        new_password: "Contraseña nueva",
        confirm_new_password: "Confirmar contraseña nueva",
        new_password_placeholder: "Ingrese su nueva contraseña",
        new_confirm_password_placeholder: "Confirme su contraseña nueva",
        reset_code_expired: "Enlace de reinicio expirado, solicitelo nuevamente",
        reset_password_request: "Restablece tu contraseña",
        reset_password_request_button: "Solicitar reinicio de contraseña",
        password_reset_success_text: "Reinicio de contraseña exitoso. Ahora puedes iniciar sesión normalmente.",
        wallet: "Activos",
        converter: "Convertir",
        deposit: "Depositar",
        peertopeer: "Peer2peer",
        payrolls: "Transferencias",
        withdrawal: "Retirar",
        deposit_noun: "Depósito",
        unknown: "Desconocido",
        withdrawal_noun: "Retiro",
        cards: "Tarjetas",
        profile: "Perfil",
        modal_deposit: {
            title: "Solicitud de depósito",
            info: "Has creado una solicitud de deposito, por favor sigue los pasos en la nueva pestaña para terminar este proceso",
            description: "En caso no se abrió ninguna, haga click en el enlace de abajo",
            link: "Click aquí",
            button: "Ir a billetera"  
        },
        modal_withdrawal: {
            title: "Solicitud de Retiro",
            info: "Has creado una solicitud de retiro, por favor sigue los pasos en la nueva pestaña para completar este proceso.",
            info_card: "Hemos registrado tu solicitud de retiro. Ten en cuenta que la confirmación puede tardar hasta 24 horas.",
            info_crypto: "Has creado una solicitud de retiro. Por favor, espera hasta la confirmación para ver tu saldo actualizado.",
            description: "Si no se abrió ninguna pestaña, haz clic en el enlace de abajo.",
            link: "Haz clic aquí",
            button: "Ir a la billetera"
        },
        payment_account_modal: {
            title: "Crea una cuenta de pago",
        },
        payment_account_info_modal: {
            title: "Información de la cuenta de pago",
        },
        ligo_card_actions: {
            active: "Para activar tu tarjeta LIGO, primero debes activarla a través de LIGO.",
            blocked: "Para bloquear tu tarjeta LIGO, primero contacta al soporte de LIGO."
        },
        card_inswitch_request: {
            success: "Tarjeta virtual creada",
            error: "Error solicitando tarjeta virtual"
        },
        card_request: {
            success: "Solicitud de tarjeta creada",
            error: "Error solicitando tarjeta",
        },
        card_action_modal: {
            activate: {
                title: "Activa Tu Tarjeta Nemo",
                text: "Es necesario activar tu tarjeta antes de usarla.",
                success: "Tarjeta activada con éxito.",
                inswitch_error: "No se pudo activar la tarjeta.",
                ligo_error: "Para activar tu tarjeta LIGO, primero debes activarla a través de LIGO.",
            },
            blocked: {
                title: "Bloquea Tu Tarjeta Nemo",
                text: "Todas las transacciones de esta tarjeta serán congeladas.",
                success: "Tarjeta congelada exitosamente.",
                error: "Ocurrió un error inesperado.",
                ligo_error: "Para bloquear tu tarjeta LIGO, primero contacta al soporte de LIGO."
            },
            details: {
                title: "Detalles de la Tarjeta Nemo",
                text: "",
                success: "",
                error: ""
            },
            fund: {
                title: "Añade Fondos a Tu Tarjeta Nemo",
                text: "Para añadir fondos, realiza un retiro y selecciona tu cuenta de pago USD de la tarjeta Nemo.",
                success: "",
                error: ""
            },
            pin: {
                title: "Actualizar PIN",
                text: "Ingrese un PIN distinto al PIN actual",
                success: "PIN actualizado exitosamente.",
                error: "Error al actualizar el PIN",
                invalid: "PIN no válido, inténtelo de nuevo",
                form: {
                  enter_pin: "Nuevo PIN",
                  enter_pin_placeholder: "Ingrese su nuevo PIN",
                  confirm_pin: "Confirmar PIN",
                  confirm_pin_placeholder: "Ingrese PIN nuevamente",
                  confirmation_code: "Código de confirmación",
                  enter_confirmation_code: "Ingrese el código de confirmación",
                  send_code: "Enviar código de confirmación",
                  pin_error: "Los valores no son iguales",
                }
            }
        },
        notFoundPage: {
            title: "Página no encontrada" ,
            subtitle: "La página solicitada no se ha encontrado."
        },
        create_wallet: "Crear billetera",
        create_wallet_title: "Crea tu nueva dirección para  ",
        create_wallet_sub_title: "Crear dirección para la red",
        missing_form_fields : "Falta completar los campos",
        take_me_nemo: "Llévame a NEMO",
        balance: "Balance",
        show_balance: "Mostrar saldo",
        no_balance: "Sin saldo",
        assets: "Activos",
        total_balance: "Balance total",
        equivalent_balance: "Balance equivalente",
        available_balance: "Balance disponible",
        balance_after_withdrawal: "Balance después del retiro",
        small_balances: "Balances pequeños",
        long_coin_names: {
                COP: "Peso colombiano",
                USDT: "USD Tether",
                ETH: "Ethereum",
                BTC: "Bitcoin",
                PEN: "Sol Peruano",
                USD: "Dólar Estadounidense",
        },
        two_step_verification: "Verificación de dos pasos",
        first_name: "Nombre",
        last_name: "Apellidos",
        full_name: "Nombre completo",
        profile_header: "Mi perfil",
        cards_header: "Tu tarjeta",
        peertopeer_header: "Peer to peer",
        peertopeer_title: "Intercambia activos con otros usuarios",
        peertopeer_send: "Enviar",
        peertopeer_back: "Atrás",
        peertopeer_publicity_title: "Intercambia activos",
        peertopeer_publicity_description: "Realiza intercambios de activos de forma segura, rápida y transparente. ¡Sin tarifas!",
        peertopeer_username_placeholder: "Ingrese nombre de usuario",
        peertopeer_minimum_amount: "Mínimo",
        peertopeer_maximum_amount: "Máximo",
        peertopeer_send_to: "Enviando a",
        peertopeer_destination: "Destinatario",
        peertopeer_insert_username: "Ingresa el nombre de usuario",
        peertopeer_username_success: "Usuario válido",
        peertopeer_success: "Transferencia completada",
        peertopeer_errors: {
            invalid_value: "Por favor ingrese solo números",
            invalid_qr: "El código QR es inválido",
            too_much_decimals: "No puedes exceder el máximo de decimales",
            value_lower_than_min: "El valor ingresado es menor que el mínimo",
            value_higher_than_max: "El valor ingresado excede el máximo",
            invalid_username: "El usuario no existe o no es válido",
            cannot_send_to_self: "No puedes enviarte activos a ti mismo",
            transfer_error: "Hubo un error al hacer la transferencia",
            not_enough_balance: "No tienes suficiente saldo para realizar la transferencia",
            too_many_digits: "No puedes exceder el máximo de dígitos",
        },
        peertopeer_modal: {
            title: "Transferencia completada",
            user: "usuario",
            id: "id",
            close: "Volver"
        },
        country: "País",
        phone: "Teléfono",
        coin_price: "Precio moneda",
        cost_price: "Precio costo",
        amount: "Cantidad",
        limits: "Límites",
        limit_overflow: "El monto debe estar entre los límites",
        limit_overflow_disclaimer: "El monto debe estar entre los límites, de lo contrario no será acreditado",
        min_amount: "Cantidad Mínima",
        max_amount: "Cantidad Máxima",
        recieve_amount: "Cantidad a recibir",
        fee: "Comisión",
        min_fee: "Comisión mínima",
        actions: "Acciones",
        h_change: "Cambio 24h",
        coin: "Moneda",
        search_coin: "Buscar moneda",
        card: "Tarjeta",
        bank: "Banco",
        cash: "Efectivo",
        date: "Fecha",
        select_coin: "Selecciona una moneda",
        select_blockchain: "Selecciona una red",
        blockchain: "Red",
        blockchain_currency: "Red",
        select_method: "Selecciona un método",
        select_option: "Selecciona una opción",
        no_option: "No hay opción disponible",
        select_payment_account: "Selecciona una cuenta de pago",
        bank_name: "Nombre del banco",
        account_type: "Tipo de cuenta",
        account_type_checking : "Cuenta Corriente",
        account_type_savings : "Cuenta Ahorro",
        account_number: "Número de cuenta",
        phone_number: "Número de célular",
        firstname: "Nombre",
        lastname: "Apellido",
        document_number: "Número de documento",
        document_type: "Tipo de documento",
        nationalId: "Cédula de Ciudadanía",
        foreignerId: "Cédula de Extranjería",
        passport: "Pasaporte",
        chanceryId: "Tarjeta Diplomática",
        ruc: "RUC",
        display_name: "Alias de la cuenta",
        display_name_description: "Ingrese un alias ",
        address: "Dirección",
        city: "Ciudad",
        installments: "Cuotas",
        send: "Enviar",
        insert: "Ingrese su ",
        success_copy_address: "Dirección copiada exitosamente",
        error_copy_address: "Hubo un error al realizar la copia de la dirección",
        copied_to_clipboard: "Copiado al portapapeles",
        error_copy_clipboard: "Error al copiar al portapapeles",
        payment_account_created: "Nueva cuenta de pago creada",
        balance_history: "Balance / Historial",
        selling: "Das",
        getting: "Recibes",
        convert: "Convertir",
        exceeds_balance_more_than_max: "La cantidad seleccionada excede el saldo actual o el tamaño máximo de la orden para el activo a dar",
        less_than_min: "La cantidad seleccionada es menor que el mínimo aceptable para el activo a dar",
        selected_amount_not_available: "La cantidad seleccionada no está disponible, por favor contacte a soporte",
        movements:"Movimientos",
        order_executed: "Orden ejecutada exitosamente",
        traded: "Se intercambió",
        for: "por",
        invalid_address: "Cuenta de pago inválida",
        payouts_freezed: "Los pagos están actualmente congelados debido a un restablecimiento de contraseña.",
        next:"Siguiente",
        previous:"Anterior",
        nomovements:"Todavía no tienes historial de transacciones",
        nolists: "Todavía no tienes listas de usuarios",
        nomasstransfers: "Todavía no tienes transferencias masivas",
        status_mapping: {
            pending: "Pendiente",
            to_be_sent: "Para enviar",
            done: "Hecho",  
            canceled: "Cancelado",
            cancelled: "Cancelado",
            failed: "Fallido",
            processing: "Processing",
            completed: "Completado",
            unknown: "Desconocido",
            wait_confirmation: "Confirmando",
            reverted: "Revertido",
            verifying: "Verificando",
          },
        statuses: "Estado",
        available: "Disponible",
        trade_history: "Historial",
        gave_got: "Diste | Recibiste",
        gave: "Diste",
        got: "Recibiste",
        price: "Precio",
        no_balance_conv: "Balance moneda base es 0",
        fee_apply_t: "Comisión aplicada de",
        fee_equivalent_t: "equivalente a",
        hello_nickname: "Bienvenido,",
        birthday: "Fecha de nacimiento",
        old_password: "Contraseña actual",
        old_password_placeholder: "Ingrese su contraseña actual",
        change_password_label: "Contraseña",
        change_password: "Cambiar contraseña",
        change_password_button: "Cambiar",
        enable_two_fa: "Habilitar 2FA",
        addresses_label: "Mis domicilios",
        add_address_button: "Agregar domicilio",
        request_virtual_card: "Solicitar tarjeta virtual",
        request_card: "Solicitar tarjeta",
        wrong_old_password: "Contraseña actual incorrecta",
        security: "Seguridad",
        addresses: "Domicilios",
        two_fa: "Autenticación de dos factores",
        enable: "Habilitar",
        disable: "Deshabilitar",
        two_fa_off: "2FA deshabilitado",
        two_fa_on: "2FA habilitado",
        tfa_explanation: "Escanear código QR con algún app autenticador",
        scan_qr: "Escanear",
        stop_scan_qr: "Cancelar",
        scan_qr_modal: {
            title: "Escanear código QR",
            error_camera: "Hubo un error, por favor verifica los permisos de tu cámara",
            error_scanner: "Error de javascript",
            close: "Cancelar"
        },
        back: "Volver",
        submit: "Enviar",
        ready: "Listo",
        put_authenticator_otp: "Ingrese el OTP del autenticador",
        tfa_otp_input_placeholder: "XXXXXX",
        otp_failed: "Código erroneo",
        tfa_setup_successful: "Autenticación de 2 factores exitosa",
        tfa_disable_successful: "Autenticación de 2 factores removida exitosamente",
        card_coin: "Activo para retiros",
        card_balance: "Balance",
        card_options_title: "Acciones",
        card_asset_info_modal: {
            // NOTE USDT HERE IS HARDCODED
            title: 'Activo para retiros',
            text: 'El activo seleccionado se usará para los retiros o compras con tu tarjeta Nemo, que está en USD. Actualmente, solo se admite USDT, pero pronto estarán disponibles más activos. La conversión se maneja internamente al precio de mercado.',
        },
        card_pan: "Número de Tarjeta",
        card_expiry: "Fecha de expiración",
        card_cvv: "CVV",
        card_data_disclaimer: "Por motivos de seguridad, los datos de la tarjeta (número y CVV) se generan de forma dinámica y pueden cambiar cada vez que visualices los detalles.",
        inswitch: "Tarjeta Virtual", // Card vendor name
        ligo: "Tarjeta Ligo", // Card vendor name
        rain: "Tarjeta Nemo",
        activate_card: "Activar",
        block_card: "Bloquear",
        show_details: "Mostrar Datos",
        add_funds: "Agregar Fondos",
        update_pin: "Actualizar PIN",
        inswitch_disclaimer: `El titular de la cuenta bancaria debe ser el mismo titular de la cuenta de ${localConfig.brand.toUpperCase()}. Es responsabilidad del usuario que el nombre y número de identificación de la cuenta bancaria coincidan con los datos registrados en su cuenta de ${localConfig.brand.toUpperCase()}.`,
        website_under_maintenance: "Plataforma en mantenimiento, estaremos de vuelta en unos momentos.",
        nemocard: "Nemo Card",
        active: "Activa",
        inactive: "Inactiva",
        blocked: "Bloqueada",
        suspended: "Suspendida",
        assigned: "No Activa",
        unassigned: "No Asignada",
        error_refresh_page: "Intenta nuevamente en unos minutos",
        delete: "Eliminar",
        bank_transfer: "Transferencia bancaria",
        account_credit: "Abono a cuenta",
        cci_number: "CCI",
        title: {
            default: "Compra y Vende Criptomonedas | NEMO Latam",
            "": "Billetera y Balance",
            converter: "Convierte Monedas",
            peertopeer: "Intercambio de Activos",
            payrolls: "Paga empleados en cripto o fiat",
            deposit: "Deposita Cripto y FIAT",
            withdraw: "Retira Cripto y FIAT",
            profile: "Perfil y Configuración",
            cards: "Tarjetas Nemo",
            kyc: "Verifica tu identidad",
            login: "Inicia sesión para comenzar",
            register: "Crea una cuenta",
            "confirm-register": "Verifica tu correo electrónico",
            "reset-password": "Restablece tu contraseña",
            support: "Soporte",
            maintenance: "Página en mantenimiento",
            "*": "No encontrado",
        },
        converter_errors: {
            invalid_value: "Por favor ingrese solo números",
            value_lower_than_min: "El valor ingresado es menor que el mínimo",
            value_higher_than_max: "El valor ingresado excede el tamaño máximo de la orden para el activo a dar",
            value_higher_than_balance: "El valor ingresado excede el saldo disponible",
        },
        try_later_or_contact_support: "Ocurrió un error, intente de nuevo después o contacte con soporte",
        account_block: "Cuenta bloqueada, por favor contacte a soporte",
        other: "Otro",
        withdraw: "Retirar",
        masked_pan: "Número de tarjeta",
        type: "Tipo",
        physical: "Física",
        brand: "Marca",
        mastercard: "Mastercard",
        expiry_mm_yyyy: "Fecha de expiración",
        visa: "Visa",
        virtual: "Tarjeta virtual",
        nemo_card_request: "¡Solicita tu Nemo Card!",
        nemo_card_request_info: "Tus cripto al mundo real",
        nemo_card_question_1: "¿Cómo obtenerla?",
        nemo_card_answer_1_a: "Convierte tus activos digitales en experiencias reales y transforma tus compras en momentos únicos.",
        nemo_card_answer_1_b: "Dirección de entrega: Av. Santa Cruz 198, San Isidro, Lima",
        nemo_card_answer_1_c: "Tarjeta virtual: Pídela a travez de la plataforma.",
        nemo_card_answer_1_d: "Tarjeta física: ¡Proximamente!, pronto podrás solicitar este servicio.",
        nemo_card_question_2: "Características principales:",
        nemo_card_answer_2_a: "Marca: Visa, aceptada en millones de establecimientos en todo el mundo.",
        nemo_card_answer_2_b: "Beneficios: Agilidad, conveniencia y control total sobre tus fondos.",
        nemo_card_answer_2_c: "Marca: Mastercard, aceptada en millones de establecimientos en todo el mundo.",
        nemo_card_call_to_action: "Paga en cualquier establecimiento, retira efectivo en cajeros y administra tu dinero como nunca antes.",
        nemo_card_details_warning: "Por motivos de seguridad, los datos de la tarjeta (número y CVV) se generan de forma dinámica y pueden cambiar cada vez que visualices los detalles.",
        wallet_history_item: {
            Withdrawal: "Retiro",
            Deposit: "Depósito",
            original_label: "Original",
            fee_label: "Tarifa",
            total_label: "Total"
        },
        card_delivery: "Entrega de la tarjeta",
        delivery_method: "Método de entrega",
        pick_up:  "Recógela personalmente",
        delivery_address: "Dirección de entrega",
        nemo_address: "Av. Santa Cruz 198, San Isidro, Lima",
        nemo_office_address: localConfig.countryCode === "PE" ? "Av. Santa Cruz 198, San Isidro, Lima" : "Calle 6 Sur #43A-100, Medellín, Colombia",
        user_address: {
            title: "Agregar domicilio",
            search_address_label: "Buscar domicilio",
            search_address_placeholder: "Ingrese su domicilio",
            street_label: "Calle",
            street_placeholder: "Ingrese su calle",
            city_label: "Ciudad",
            city_placeholder: "Ingrese su ciudad",
            state_label: "Estado",
            state_placeholder: "Ingrese su estado",
            zip_code_label: "Código postal",
            zip_code_placeholder: "Ingrese su código postal",
            country_label: "País",
            country_placeholder: "Ingrese su país",
            submit: "Agregar domicilio",
            address_added: "Dirección agregada exitosamente",
            unexpected_error: "Ocurrió un error inesperado",
            too_many_addresses: "Has alcanzado el límite de direcciones permitidas",
        },
        card_request_form: {
            request_sent: "Solicitud enviada",
            request_sent_text: "¡Estas a pocos pasos de tener tu Nemo Card!",
            virtual_card: "Tarjeta virtual",
            virtual_card_description: "Tu tarjeta aparecerá aquí cuando sea aprobada",
            info: "Tu solicitud de tarjeta será revisada por nuestro equipo. Puedes elegir recogerla o que se te entregue en tu dirección",
            title: "Crear solicitud de tarjeta",
            phone_number: "Número de teléfono",
            phone_code: "Código",
            phone_number_placeholder: "Ingrese su número de teléfono",
            user_address: "Ingrese su domicilio fiscal",
            select_address: "Seleccionar dirección de entrega",
            select_card_type: "Seleccionar tipo de tarjeta",
            select_type: "Seleccionar tipo de entrega",
            monthly_volume: "Volumen mensual esperado",
            monthly_volume_placeholder: "Ingrese un monto en dolares",
            physical: "Física",
            virtual: "Virtual",
            pickup: "Recoger en oficina",
            delivery: "Entrega a domicilio",
            submit: "Enviar",
            success: "Solicitud de tarjeta creada exitosamente",
            error: "Ocurrió un error inesperado al crear la solicitud de tarjeta",
            created: "Esperando aprobación",
            cancel_request: "Cancelar solicitud",
            disclaimer: "Recibirás un correo con las indicaciones para recoger su tarjeta",
            declined: "Solicitud rechazada"
        },
        card_request_cancel: {
            title: "Cancelar solicitud de tarjeta",
            description: "Por favor confirma que deseas cancelar tu solicitud de tarjeta",
            action: "Confirmar"
        },
        months: {
            1: "Ene",
            2: "Feb",
            3: "Mar",
            4: "Abr",
            5: "May",
            6: "Jun",
            7: "Jul",
            8: "Ago",
            9: "Sep",
            10: "Oct",
            11: "Nov",
            12: "Dic"
        },
        support: "Soporte",
        tickets: "Tickets",
        subject: "Asunto",
        upload_image: "Subir imagen",
        optional: "Opcional",
        sent: "Enviar",
        support_ticket_creation_success: "Ticket creado correctamente",
        support_ticket_creation_error: "No se pudo crear el ticket",
        support_ticket_size_error: "No se pudo cargar la imagen",
        ticket_new: "Nuevo",
        ticket_open: "En espera",
        ticket_pending: "Responder",
        ticket_solved: "Cerrado",
        close: "Cerrar",
        support_ticket_created_modal: {
            title: "Ticket creado con éxito",
            info: "Tu ticket ha sido creado con éxito. En unos segundos, podrás verlo en la otra sección.",
        },
        faq: "Preguntas frecuentes",
        faq_search_error: "Búsqueda vacía",
        search: "Buscar",
        no_data_search: "No se encontraron resultados",
        no_tickets: "No se encontraron tickets",
        create_support_ticket: "Crea un ticket de ayuda",
        payrolls_main_title: "Enviar transferencia masiva",
        payrolls_user_lists: "Listas de destinatarios",
        payrolls_configure: "Configurar transferencia",
        payrolls_send: "Enviar transferencia",
        payrolls_save_list: "Guardar lista",
        payrolls_clean_list: "Vaciar lista",
        payrolls_recipients: "Destinatarios",
        payrolls_valid_username: "Usuario válido",
        payrolls_user_list_created: "Lista de usuarios creada",
        payrolls_transfer_success: "Transferencia pendiente de aprobación",
        payrolls_transfer_error: "Error al realizar la transferencia",
        payrolls_transfer_name: "Transferencia",
        payrolls_form: {
            amount_placeholder: "Ingrese cantidad a enviar",
            new_email_placeholder: "Agregar correo de destinatario",
            search_user: "Buscar usuario",
            sort_invalid: "Invalidos",
            sort_amount: "Monto",
            sort_alpha: "A-Z",
            delete_user_modal: {
                title: "Eliminar usuario",
                text: "Por favor confirma que deseas eliminar al usuario:",
                confirm: "Eliminar",
                cancel: "Cancelar"
            },
            delete_all_users_modal: {
                title: "Vaciar lista",
                text: "Por favor confirma que deseas vaciar la lista de usuarios",
                confirm: "Vaciar",
                cancel: "Cancel"
            },
            delete_list_modal: {
                title: "Eliminar lista de destinatarios",
                text: "Por favor confirma que deseas eliminar la lista de destinatarios",
                confirm: "Eliminar",
                cancel: "Cancelar",
                success: "Lista de destinatarios eliminada",
                error: "Error eliminando la lista de destinatarios"
            },
            history_filters: {
                amount: "Monto",
                date: "Fecha",
                min_amount: "Monto mínimo",
                max_amount: "Monto máximo",
                start_date: "Fecha de inicio",
                end_date: "Fecha de fin",
                date_range: "Rango de fechas",
                sort_by: "Ordenar por",
                currency: "Moneda",
                min: "Min",
                max: "Max",
                newest_first: "Más recientes",
                oldest_first: "Más antiguos",
                amount_high_to_low: "Monto alto a bajo",
                amount_low_to_high: "Monto bajo a alto",
                search_user: "Buscar usuario",
                user_email: "Ingrese el correo del usuario",
                clear_filters: "Limpiar filtros",
                download_excel: "Descargar excel"
            },
            added_users: "{{new}} usuarios agregados",
            added_repeated_users: "{{repeated}} usuarios repetidos, {{new}} usuarios agregados",
            added_invalid_users: "{{invalid}} usuarios no existen o no han completado KYC",
            added_user: "Usuario agregado: {{user}}",
            updated_user: "Usuario editado {{user}}",
            deleted_user: "Usuario eliminado: {{user}}",
            deleted_all_users: "Todos los usuarios eliminados",
            no_users: "Agrege destinatarios para verlos aquí"
        },
        payrolls_summary: {
            num_users: "Número de usuarios",
            total_amount: "Monto total",
            min_amount: "Monto mínimo",
            max_amount: "Monto máximo",
            average_amount: "Monto promedio",
            current_balance: "Balance actual",
            balance_after_transaction: "Balance después de la transacción",
        },
        payrolls_file_upload: {
            title: "Cargar usuarios desde archivo",
            description: "Por favor use la plantilla e ingrese los usuarios a transferir",
            drop_here: "Arrastre y suelte el archivo aquí",
            download_template: "Descargar plantilla",
            download_template_description: "Use esta plantilla para cargar los usuarios",
            upload_file: "Subir archivo",
            upload_file_description: "Archivos aceptados: .csv, .txt, .xlsx",
            success: "Archivo procesado, agregando usuarios",
            close: "Cerrar",
            errors: {
                invalid_file_type: "Tipo de archivo inválido",
                invalid_file: "Archivo inválido o vacío",
                parse_error: "Error procesando el archivo",
                check_error: "Error al verificar los usuarios"
            }
        },
        payrolls_edit_user_modal: {
            title: "Editar usuario",
            email_label: "Ingrese el usuario del destinatario",
            email_placeholder: "Ingrese correo electrónico",
            submit: "Guardar",
            delete: "Eliminar",
            cancel: "Cancelar"
        },
        payrolls_errors: {
            cannot_send_to_self: "No puedes enviarte a ti mismo",
            duplicate_user: "El usuario ya ha sido agregado",
            invalid_username: "El usuario no existe o no ha completado su KYC",
            error_creating_user_list: "Error creando la lista de usuarios",
        },
        mass_transfers_modal: {
            title: "Transferencias masivas",
            select_transfer: "Seleccione una transferencia para ver el detalle"
        },
        create_user_list_modal: {
            title: "Guardar lista de destinatarios",
            name_label: "Nombre de la lista",
            name_placeholder: "Ingrese el nombre de la lista",
            description_label: "Descripción",
            description_placeholder: "Ingrese una descripción",
            num_users: "Usuarios",
            preferred_amount_label: "Monto preferido",
            preferred_amount_placeholder: "Ingrese el monto preferido",
            preferred_currency_label: "Moneda preferida",
            preferred_currency_placeholder: "Seleccione la moneda",
            submit: "Crear",
            cancel: "Cancelar"
        },
        send_mass_transfer_modal: {
            title: "Enviar transferencia",
            name_label: "Nombre de la transferencia",
            name_placeholder: "Ingrese el nombre de la transferencia",
            submit: "Enviar transferencia",
            cancel: "Cancelar"
        },
        edit_user_list_modal: {
            title: "Editar lista de destinatarios",
            name_label: "Nombre de la lista",
            name_placeholder: "Ingrese el nombre de la lista",
            description_label: "Descripción",
            description_placeholder: "Ingrese una descripción",
            num_users: "Usuarios",
            new_email_placeholder: "Agregar correo de destinatario",
            invalid_username: "Usuario inválido",
            preferred_amount_label: "Monto preferido",
            preferred_amount_placeholder: "Ingrese el monto preferido",
            preferred_currency_label: "Moneda preferida",
            preferred_currency_placeholder: "Seleccione la moneda",
            success: "Lista de usuarios editada exitosamente",
            error_updating_user_list: "Error editando la lista de usuarios",
            submit: "Guardar",
            cancel: "Cancelar"
        },
        check_username_input: {
            placeholder: "Ingrese el usuario",
            valid_username: "Usuario válido",
            invalid_username: "Usuario inválido",
            cannot_send_to_self: "No puedes enviarte a ti mismo",
            repeated_username: "Usuario repetido"
        },
        creating_mass_transfer: "Creando transferencia masiva...",
        list_name: "Nombre de la lista",
        list_name_required: "El nombre de la lista es requerido",
        add_recipient: "Agregar destinatario",
        remove_recipient: "Eliminar destinatario",
        fill_all_required_fields: "Por favor complete todos los campos requeridos",
        mass_transfer_created_successfully: "Transferencia masiva creada exitosamente",
        error_creating_mass_transfer: "Error al crear la transferencia masiva",
        recent_mass_transfers: "Historial",
        loading: "Cargando...",
        no_transfers_yet: "Aún no hay transferencias masivas",
        recipients_count: "{{count}} destinatarios",
        status_options: {
            pending: "Pendiente",
            processing: "Procesando",
            completed: "Completada",
            failed: "Fallida"
        },
        user_list: "Lista de usuarios",
        create_new_list: "Crear nueva lista",
        select_existing_list: "Seleccionar lista existente",
        transfer_details: "Detalles de la transferencia",
        remove: "Eliminar",
        select_or_create_list: "Por favor seleccione o cree una lista de usuarios",
        fill_all_emails: "Por favor complete todos los correos electrónicos",
        amount_required: "El monto es requerido",
        no_user_lists: "Aún no hay listas de usuarios",
        user_list_modal: {
            title: "Agregar lista de destinatarios",
            name_label: "Nombre",
            description_label: "Descripción",
            search_placeholder: "Buscar usuario",
            no_users: "No se encontraron usuarios",
            total_users: "Total",
            preferred_amount: "Monto preferido",
            select_button: "Agregar",
            close_button: "Cerrar"
        },
        mass_transfer_item: {
            recipients_count: "{{count}} destinatarios",
            total_label: "Total",
            amount_label: "Monto",
            status: {
              pending: "Pendiente",
              processing: "Procesando",
              completed: "Completada",
              failed: "Fallida",
              cancelled: "Cancelada"
            }
        },
        need_help: "¿Necesitas ayuda?",
        refer: "Invita a un amigo",
        referral_section: {
            title: "Invita a tus amigos",
            description: "Comparte tu código de invitación con amigos para que se unan.",
            copy_code: "Copiar enlace de invitación"
        },
        conection_slow: "Conexión lenta, click aquí para intentar nuevamente o contactar soporte si el problema persiste",
        nemo_card_top: "Convierte tus activos digitales en experiencias reales y transforma tus compras en momentos únicos.",
        nemo_card_mid: "Paga en cualquier establecimiento, retira efectivo en cajeros y administra tu dinero como nunca antes.",
        nemo_card_mid_list_item_1: "Úsala en miles de establecimientos físicos y online.",
        nemo_card_mid_list_item_2: "Retira en cajeros automáticos de manera rápida y segura.",
        nemo_card_mid_list_item_3: "Sin papeles, sin complicaciones. ¡En minutos tu solicitud estará en marcha!",
        nemo_card_mid_end: "Recíbela de forma segura en nuestras oficinas o en la puerta de tu casa."
    },
    en: {
        any_question: "Get to know us",
        bring_crypto :"Bring your crypto",
        one_card_all_crypto: "One card for all your crypto",
        nemo_card_top: "Turn your digital assets into real experiences and transform your purchases into unique moments.",
        nemo_card_mid: "Pay at any establishment, withdraw cash at ATMs, and manage your money like never before.",
        nemo_card_mid_list_item_1: "Use it at thousands of physical and online establishments.",
        nemo_card_mid_list_item_2: "Withdraw from ATMs quickly and securely.",
        nemo_card_mid_list_item_3: "No paperwork, no complications. In minutes, your request will be on its way!",
        nemo_card_mid_end: "Receive it securely at our offices or at your doorstep.",
        amount_too_high : "Amount too high",
        no_results_found: "No results found",
        enter_amount :"Enter amount",
        amount_exceeds_balance : "Amount exceeds balance",
        type_search: "Type to search...",
        create_payment:"Add",
        amount_too_low: "Amount too low",
        country_not_supported: "Country not admitted",
        country_missing: "Country not selected",
        fee_note: "Note: Banks can charge additional transfeer fees",
        fee_breakdown: "Fee breakdown",
        amount_to_receive: "Amount to recieve",
        fee_deducted: "Fee deducted",
        fee_calculation: "Fee",
        max_withdrawal:"Max withdrawal",
        min_withdrawal:"Min withdrawal",
        invalid_value: "Invalid Value",
        limits_note:"Note: Fees are included in limits",
        rates_are_referential: "*Shown rates are referential only",
        input_number_to_see_rates: "Enter amount to see rate",
        please_try_again: "Please try again",
        asset: "Asset",
        pan: "PAN",
        cvc: "CVC",
        occupation: "Occupation",
        annualSalary: "Annual Salary",
        accountPurpose: "Account Purpose",
        validating_kyc_data_title: "We are processing your info",
        validating_kyc_data_text: `In a few moments, you will be able to enter ${localConfig.brand}`,
        not_available: "Not available",
        login_or_register_to_enter_raffle: "Sign in or register to participate",
        success_registration_raffle: "Registration success",
        we_are: "We are in",
        maintenance: "maintenance",
        icon: usacircle,
        apple_download_badge: appstoreen,
        google_download_badge: googleplayen,
        continue: "Continue",
        description: "Description",
        login: "Log in",
        logout: "Log out",
        email: "Email Address",
        password: "Password",
        email_placeholder: "Enter your email address",
        password_placeholder: "Enter your password",
        dont_have_account: "Don't have an account?",
        forgot_password: "Forgot your password?",
        invalid_login: "Invalid credentials",
        reset_psw: "Due to the update, it is necessary to reset your password.",
        confirm_password: "Confirm password",
        confirm_password_placeholder:"Enter your password again",
        register: "Create account",
        register_success: "Account created successfully",
        register_fail: "Account creation failed",
        already_have_account: "Already have an account?",
        password_mismatch: "Passwords don't match",
        password_too_short: "At least 8 characters",
        password_needs_uppercase: "At least an uppercase letter",
        password_needs_lowercase: "At least a lowercase letter",
        password_needs_number: "At least 1 digit",
        password_needs_special: "At least one special character",
        hinting_regex_error: "Password does not meet minimum requirements",
        complete_the_captcha: "Complete the CAPTCHA",
        register_failed: "Account creation failed, please try again",
        balance_navbar: "Total balance",
        terms_text1: "I have read and agree to the",
        terms_text2: "of Nemo Latam.",
        terms_and_conditions: "Terms and Conditions",
        card_term1_texta: "I accept the",
        card_term1_textb: "E-Sign Consent",
        card_term2_texta: "I accept the",
        card_term2_textb: "Nemo Card Terms",
        card_term2_textc: ", and the",
        card_term2_textd: "Nemo Privacy Policy",
        card_term3_texta: "I certify that the information I have provided is accurate and that I will abide by all the rules and requirements related to my Nemo Spend Card.",
        card_term4_texta: "I acknowledge that applying for the Nemo Spend Card does not constitute unauthorized solicitation.",
        privacy_policy: "Privacy Policy",
        data_processing_policy: "Data Processing Policy",
        declaration_text1: "I have read and confirm the",
        goods_declaration: "Declaration of Source of Funds.",
        authorization_text1: "I have read and confirm the",
        data_authorization: "Authorization for the processing",
        authorization_text2: "of my personal data.",
        confirm_email: "Confirm email",
        email_code: "Confirmation code",
        email_code_text: "Email with a code has been sent to you, please enter it in the form below",
        confirm: "Confirm",
        cancel: "Cancel",
        code_placeholder: "Enter your email confirmation code",
        resent_code: "Code sent",
        email_confirmed: "E-mail verified. Login to verify your identity",
        verify_email: "Verify email",
        back_to_login: "Back to login",
        resend_code: "Resend code",
        in: "in",
        name: "Name",
        seconds: "seconds",
        click_to: "Click to",
        click_here: "Click here",
        incorrect_code: "Incorrect code",
        reset_password: "Reset password",
        email_sent: "Email sent",
        error: "Error",
        unexpected_error: "An unexpected error occurred",
        invalid_confirmation_code: "Invalid confirmation code",
        captcha_failed: "Captcha failed",
        reset_continue_text: "We have sent you an email with instructions on how to proceed with your password reset.",
        password_reset_success: "Password reset successfully",
        new_password: "New password",
        confirm_new_password: "Confirm new password",
        new_password_placeholder: "Enter your new password",
        new_confirm_password_placeholder: "Confirm your new password",
        reset_code_expired: "Reset link expired, request a new one",
        reset_password_request: "Password reset request",
        reset_password_request_button: "Request password reset",
        password_reset_success_text: "Password reset successful. You may now log in normally.",
        wallet: "Wallet",
        converter: "Converter",
        deposit: "Deposit",
        peertopeer: "Peer2peer",
        payrolls: "Transfers",
        withdrawal: "Withdrawal",
        deposit_noun: "Deposit",
        unknown: "Unknown",
        withdrawal_noun: "Withdrawal",
        cards: "Cards",
        profile: "Profile",
        modal_deposit: {
            title: "Deposit Request",
            info: "You have created a deposit request, please follow the steps in the new tab to complete this process.",
            description: "If no tab was opened, click the link below.",
            link: "Click here",
            button: "Go to wallet"
        },
        modal_withdrawal: {
            title: "Withdrawal Request",
            info: "You have created a withdrawal request, please follow the steps in the new tab to complete this process.",
            info_card: "Your withdrawal request has been received. Please note that confirmation may take up to 24 hours.",
            info_crypto: "You have created a withdrawal request. Please wait until confirmation to see your balance updated",
            description: "If no tab was opened, click the link below.",
            link: "Click here",
            button: "Go to wallet"
        },
        payment_account_modal: {
            title: "Create payment account",
        },
        payment_account_info_modal: {
            title: "Payment account info",
        },
        active_card_modal: {
            title: "Activate Your Nemo Card",
            text: "To use your card, it is necessary to activate it. Please enter the tracking number of the card.",
            placeholder: "Insert the tracking number"
        },
        ligo_card_actions: {
            active: "To activate your LIGO card, you must first activate it through LIGO.",
            block: "To block your LIGO card, first please contact LIGO support."
        },
        card_inswitch_request: {
            success: "Virtual card created",
            error: "Error requesting card"
        },
        card_request: {
            success: "Card request created",
            error: "Error requesting card",
        },
        card_action_modal: {
            activate: {
                title: "Activate Your Nemo Card",
                text: "Your card must be activated before it can be used.",
                success: "Card activated successfully.",
                inswitch_error: "The card could not be activated.",
                ligo_active: "To activate your LIGO card, you must first activate it through LIGO.",
            },
            blocked: {
                title: "Block Your Nemo Card",
                text: "All transactions on this card will be block.",
                success: "Card successfully blocked.",
                inswitch_error: "An unexpected error occurred.",
                ligo_error: "To block your LIGO card, first please contact LIGO support."
            },
            details: {
                title: "Nemo Card Details",
                text: "",
                success: "",
                inswitch_error: "",
                ligo_error: ""
            },
            fund: {
                title: "Add Funds to Your Nemo Card",
                text: "To add funds, make a withdrawal and select your USD Nemo Card payment account.",
                success: "",
                inswitch_error: "",
                ligo_error: ""
            },
            pin: {
                title: "Update Your PIN",
                text: "Enter a PIN other than the current PIN",
                success: "PIN updated successfully",
                error: "Error when updating PIN",
                invalid: "Invalid PIN, please try again",
                form: {
                  enter_pin: "New PIN",
                  enter_pin_placeholder: "Enter your new PIN",
                  confirm_pin: "Confirm PIN",
                  confirm_pin_placeholder: "Enter your PIN again",
                  confirmation_code: "Confirmation code",
                  enter_confirmation_code: "Enter the confirmation code",
                  send_code: "Send confirmation code",
                  pin_error: "The values are not equal"
                }
            }
        },
        notFoundPage: {
            title: "Page not found" ,
            subtitle: "The page you requested could not be found."
        }, 
        create_wallet: "Create wallet",
        create_wallet_title: "Create new address for",
        create_wallet_sub_title: "Create address for the network",
        missing_form_fields : "Missing form fields",
        take_me_nemo: "Take me to NEMO",
        balance: "Balance",
        show_balance: "Show balance",
        no_balance: "No balance",
        assets: "Assets",
        total_balance: "Total balance",
        equivalent_balance: "Equivalent balance",
        available_balance: "Available Balance",
        balance_after_withdrawal: "Balance after withdrawal",
        small_balances: "Small balances",
        long_coin_names: {
                COP: "Colombian peso",
                USDT: "USD Tether",
                ETH: "Ethereum",
                BTC: "Bitcoin",
                PEN: "Peruvian Sol",
                USD: "US Dollar",
        },
        two_step_verification: "2-Step verification",
        first_name: "First name",
        last_name: "Last name",
        full_name: "Full name",
        profile_header: "My profile",
        cards_header: "Your Card",
        peertopeer_header: "Peer to peer",
        peertopeer_title: "Exchange assets with other users",
        peertopeer_send: "Send",
        peertopeer_back: "Back",
        peertopeer_publicity_title: "Peer-to-Peer Asset Exchange",
        peertopeer_publicity_description: "Execute asset exchanges securely, quickly, and transparently. With no fee!",
        peertopeer_username_placeholder: "Insert username",
        peertopeer_minimum_amount: "Min",
        peertopeer_maximum_amount: "Max",
        peertopeer_send_to: "Sending to",
        peertopeer_destination: "Destination",
        peertopeer_insert_username: "Enter the username",
        peertopeer_username_success: "Username is valid",
        peertopeer_success: "Transfer completed",
        peertopeer_errors: {
            invalid_value: "The entered value is not a number",
            invalid_qr: "QR code is invalid",
            too_much_decimals: "You cant exceed the maximum amount of decimals",
            value_lower_than_min: "The entered value is lower than the minimum",
            value_higher_than_max: "The entered value exceeds the maximum",
            invalid_username: "El usuario no existe o no es válido",
            cannot_send_to_self: "You can't send assets to yourself",
            transfer_error: "There was an error making the transfer",
            not_enough_balance: "You don't have enough balance to make the transfer",
            too_many_digits: "Can´t exceed 10 digits in the amount",
        },
        peertopeer_modal: {
            title: "Transfer complete",
            user: "user",
            id: "id",
            close: "Back"
        },
        country: "Country",
        coin_price: "Coin price",
        cost_price: "Cost price",
        amount: "Amount",
        limits: "Limits",
        limit_overflow: "Amount should between the limits",
        limit_overflow_disclaimer: "The amount must be within the limits; otherwise, it will not be credited.",
        min_amount: "Min amount",
        max_amount: "Max amount",
        recieve_amount: "Receive amount",
        fee: "Fee",
        min_fee: "Min fee",
        actions: "Actions",
        h_change: "24h change",
        coin: "Coin",
        search_coin: "Search coin",
        card: "Card",
        bank: "Bank",
        cash: "Cash",
        date: "Date",        
        select_coin: "Select a coin",
        select_blockchain: "Select a network",
        blockchain: "Blockchain",
        blockchain_currency: "Blockchain",
        select_method: "Select a method",
        select_option: "Select an option",
        no_option: "No option available",
        select_payment_account: "Select a payment account",
        bank_name: "Bank name",
        account_type: "Account type",
        account_type_checking : "Checking account",
        account_type_savings : "Savings account",
        account_number: "Account number", 
        phone_number: "Phone number",
        firstname: "First Name",
        lastname: "Surname",
        document_number: "Document Number",
        document_type: "Document Type",
        nationalId: "Citizenship ID",
        foreignerId: "Foreigner ID",
        passport: "Passport",
        chanceryId: "Diplomatic ID",    
        ruc: "RUC",
        display_name: "Display Name", 
        display_name_description: "Enter an alias",
        address: "Address",
        city: "City",
        phone: "Phone",
        installments: "Installments",
        send: "Send",
        insert: "Insert your ",
        success_copy_address: "Address copied successfully",
        error_copy_address: "There was an error copying the address",
        copied_to_clipboard: "Copied to clipboard",
        error_copy_clipboard: "Error copying to clipboard",
        payment_account_created: "New payment account created",
        balance_history: "Balance / History",
        selling: "Give",
        getting: "Get",
        convert: "Convert",
        exceeds_balance_more_than_max: "Selected amount exceeds balance or max order size for base asset",
        less_than_min: "Selected amount is less than the order minimum for base asset",
        selected_amount_not_available: "Selected amount is not available, please contact support",
        order_executed: "Order executed successfully",
        traded: "Traded",
        for: "for",
        invalid_address: "Invalid payment account",
        payouts_freezed: "Payouts are currently frozen due to a password reset.",
        next: "Continue",
        previous:"Previous",
        movements:"Movements",
        all_coins:"All Coins",
        nomovements:"You have no transaction history",
        nolists: "You have no user lists",
        nomasstransfers: "You have no mass transfers",
        status_mapping:{
            pending: "Pending" ,
            to_be_sent: "To be sent",
            done: "Done",
            canceled: "Cancelled",
            cancelled: "Cancelled",
            failed: "Failed",
            processing: "Processing",
            completed: "Completed",
            unknown: "Unknown",
            wait_confirmation: "Confirming",
            reverted: "Reverted",
            verifying: "Verifying",
        },
        statuses: "Status",
        available: "Available",
        trade_history: "Trade history",
        gave_got: "Gave | Got",
        gave: "Gave",
        got: "Got",
        price: "Price",
        no_balance_conv: "Base asset balance is 0",
        fee_apply_t: "Applied fee of",
        fee_equivalent_t: "totaling",
        hello_nickname: "Welcome,",
        birthday: "Birthday",
        old_password: "Current password",
        old_password_placeholder: "Enter your current password",
        change_password_label: "Password",
        change_password: "Change password",
        change_password_button: "Change",
        enable_two_fa: "Enable 2FA",
        addresses_label: "My addresses",
        add_address_button: "Add home address",
        request_virtual_card: "Request virtual card",
        request_card: "Request card",
        wrong_old_password: "Wrong current password",
        security: "Security",
        addresses: "Home addresses",
        two_fa: "Two factor authentication",
        enable: "Enable",
        disable: "Disable",
        two_fa_off: "2FA disabled",
        two_fa_on: "2FA enabled",
        tfa_explanation: "Scan QR code using an authenticator app",
        scan_qr: "Scan",
        stop_scan_qr: "Cancel",
        scan_qr_modal: {
            title: "Scan QR code",
            error_camera: "There was an error, please check your camera permisions",
            error_scanner: "Javascript error",
            close: "Cancel"
        },
        back: "Back",
        submit: "Submit",
        ready: "Ready",
        put_authenticator_otp: "Enter authenticator OTP",
        tfa_otp_input_placeholder: "XXXXXX",
        otp_failed: "Wrong code",
        tfa_setup_successful: "2 factor authentication setup successful",
        tfa_disable_successful: "2 factor authentication removed successfully",
        card_coin: "Asset for withdrawals",
        card_balance: "Balance",
        card_options_title: "Actions",
        card_asset_info_modal: {
            // NOTE USDT HERE IS HARDCODED
            title: 'Asset for withdrawals',
            text: 'The selected asset will be used for withdrawals or purchases  with your Nemo Card, which is in USD. Currently, only USDT is supported, but more assets will be available soon. Conversion is handled internally at market price.',
        },
        card_pan: "Primary Account Númber",
        card_expiry: "Expiration date",
        card_cvv: "CVV",
        card_data_disclaimer: "For security reasons, the card details (number and CVV) are generated dynamically and may change each time you view the details.",
        inswitch: "Virtual Card", // Card vendor name
        ligo: "Ligo Card", // Card vendor name
        rain: "Nemo Card",
        activate_card: "Activate",
        block_card: "Block",
        show_details: "Show Details",
        add_funds: "Add Funds",
        update_pin: "Update PIN",
        inswitch_disclaimer: `The bank account holder must be the same as the ${localConfig.brand.toUpperCase()} account holder. It is the user's responsibility to ensure that the name and bank account identification number match the data registered in their ${localConfig.brand.toUpperCase()} account.`,
        website_under_maintenance: "Exchange under maintenance, we will be back shortly.",
        nemocard: "Nemo Card",
        active: "Active",
        inactive: "Inactive",
        blocked: "Blocked",
        suspended: "Suspended",
        assigned: "Not Active",
        unassigned: "Unassigned",
        error_refresh_page: "Try again in a few minutes",
        delete: "Delete",
        bank_transfer: "Bank transfer",
        account_credit: "Credit account",
        cci_number: "CCI",
        title: {
            default: "Buy & Sell Crypto | NEMO Latam",
            "": "Wallet & Balance",
            converter: "Convert Coins",
            peertopeer: "Asset Exchange",
            payrolls: "Pay employees in crypto or fiat",
            deposit: "Deposit Crypto & FIAT",
            withdraw: "Withdraw Crypto & FIAT",
            profile: "Profile & Settings",
            cards: "Nemo Cards",
            kyc: "Verify your identity",
            login: "Log in to get started",
            register: "Create an account",
            "confirm-register": "Verify your email address",
            "reset-password": "Reset your password",
            support: "Support",
            maintenance: "Site under maintenance",
            "*": "Not Found",
        },
        converter_errors: {
            invalid_value: "The input value is not a number",
            value_lower_than_min: "The input value is lower than the minimum",
            value_higher_than_max: "The input value exceeds maximum order size",
            value_higher_than_balance: "The input value exceeds the current balance",

        },
        account_block: "Account blocked, please contact support",
        other: "Other",
        withdraw: "Withdraw",
        masked_pan: "Card number",
        type: "Type",
        physical: "Physical",
        brand: "Brand",
        mastercard: "Mastercard",
        expiry_mm_yyyy: "Expiration date",
        visa: "Visa",
        virtual: "Virtual card",
        nemo_card_request: "Get your Nemo Card now!",
        nemo_card_request_info: "Bringing your crypto to the real world",
        nemo_card_question_1: "How to get it?",
        nemo_card_answer_1_a: "Delivery method: Pick it up in person.",
        nemo_card_answer_1_b: "Pickup address: Av. Santa Cruz 198, San Isidro, Lima.",
        nemo_card_answer_1_c: "Virtual card: Request it through the platform.",
        nemo_card_answer_1_d: "Physical card: Comming soon!, this service is being launched soon.",
        nemo_card_question_2: "Key Features:",
        nemo_card_answer_2_a: "Brand: Visa, accepted at millions of locations worldwide.",
        nemo_card_answer_2_b: "Benefits: Speed, convenience, and full control over your funds.",
        nemo_card_answer_2_c: "Brand: Mastercard, accepted at millions of locations worldwide.",
        nemo_card_call_to_action: "Request yours today and take your transactions to the next level!",
        nemo_card_details_warning: "For security reasons, the card details (number and CVV) are generated dynamically and may change each time you view the details.",
        wallet_history_item: {
            Withdrawal: "Withdrawal",
            Deposit: "Deposit",
            original_label: "Original",
            fee_label: "Fee",
            total_label: "Total"
        },
        card_delivery: "Card delivery",
        delivery_method: "Delivery method",
        pick_up: "Pick it up personally",
        delivery_address: "Delivery Address",
        nemo_address: "Av. Santa Cruz 198, San Isidro, Lima",
        nemo_office_address: localConfig.countryCode === "PE" ? "Av. Santa Cruz 198, San Isidro, Lima" : "Calle 6 Sur #43A-100, Medellín, Colombia",
        user_address: {
            title: "Add home address",
            search_address_label: "Search address",
            search_address_placeholder: "Enter your address",
            street_label: "Street",
            street_placeholder: "Enter your street",
            city_label: "City",
            city_placeholder: "Enter your city",
            state_label: "State",
            state_placeholder: "Enter your state",
            zip_code_label: "Zip code",
            zip_code_placeholder: "Enter your zip code",
            country_label: "Country",
            country_placeholder: "Enter your country",
            submit: "Add address",
            address_added: "Address added successfully",
            unexpected_error: "An unexpected error occurred",
            too_many_addresses: "You have reached the maximum number of addresses",
        },
        card_request_form: {
            request_sent: "Request sent",
            virtual_card: "Virtual card",
            virtual_card_description: "Your card will appear here when approved",
            request_sent_text: "You are just a few steps away from having your Nemo Card!",
            info: "Your card request will be reviewed by our team. You can choose to pick it up or have it delivered to your address",
            title: "Create Card Request",
            phone_number: "Phone number",
            phone_code: "Code",
            phone_number_placeholder: "Enter your phone number",
            user_address: "Enter your tax address",
            select_address: "Select delivery address",
            select_card_type: "Select card type",
            select_type: "Select delivery type",
            monthly_volume: "Expected monthly volume",
            monthly_volume_placeholder: "Enter an amount in dollars",
            physical: "Physical",
            virtual: "Virtual",
            pickup: "Pickup in office",
            delivery: "Delivery to address",
            submit: "Submit",
            success: "Card request created successfully",
            error: "An unexpected error occurred while creating the card request",
            created: "Waiting for approval",
            cancel_request: "Cancel request",
            disclaimer: "You will recieve an email with instructions on how to pick up your card",
            declined: "Request declined"
        },
        card_request_cancel: {
            title: "Cancel card request",
            description: "Please confirm you want to cancel your card request",
            action: "Confirm"
        },
        months: {
            1: "Jan",
            2: "Feb",
            3: "Mar",
            4: "Apr",
            5: "May",
            6: "Jun",
            7: "Jul",
            8: "Aug",
            9: "Sep",
            10: "Oct",
            11: "Nov",
            12: "Dec"
        },
        support: "Support",
        tickets: "Tickets",
        subject: "Subject",
        upload_image: "Upload image",
        optional: "Optional",
        sent: "Sent",
        support_ticket_creation_success: "Ticket created successfully",
        support_ticket_creation_error: "Failed to create the ticket",
        support_ticket_size_error: "Failed to load the image",
        ticket_new: "New",
        ticket_open: "Waiting",
        ticket_pending: "Reply Needed",
        ticket_solved: "Closed",
        close: "Close",
        support_ticket_created_modal: {
            title: "Ticket created successfully",
            info: "Your ticket has been created successfully. In a few seconds, you will be able to see it in the other section.",        
        },
        faq: "FAQ",
        faq_search_error: "Empty search",
        search: "Search",
        no_data_search: "No results found",
        no_tickets: "No tickets found",
        create_support_ticket: "Create a support ticket",
        payrolls_main_title: "Send mass transfer",
        payrolls_user_lists: "Recipient lists",
        payrolls_configure: "Configure transfer",
        payrolls_send: "Send transfer",
        payrolls_save_list: "Save list",
        payrolls_clean_list: "Clear list",
        payrolls_recipients: "Recipients",
        payrolls_valid_username: "Valid user",
        payrolls_user_list_created: "User list created",
        payrolls_transfer_success: "Transfer pending approval",
        payrolls_transfer_error: "Error making the transfer",
        payrolls_transfer_name: "Transfer",
        payrolls_form: {
            amount_placeholder: "Enter amount to send",
            new_email_placeholder: "Add recipient email",
            search_user: "Search user",
            sort_invalid: "Invalid",
            sort_amount: "Amount",
            sort_alpha: "A-Z",
            delete_user_modal: {
                title: "Delete user",
                text: "Please confirm you want to delete the user:",
                confirm: "Delete",
                cancel: "Cancel"
            },
            delete_all_users_modal: {
                title: "Clear list",
                text: "Please confirm you want to delete all users",
                confirm: "Clear",
                cancel: "Cancel"
            },
            delete_list_modal: {
                title: "Delete user list",
                text: "Please confirm you want to delete the user list",
                confirm: "Delete",
                cancel: "Cancel",
                success: "User list deleted",
                error: "Error deleting user list"
            },
            history_filters: {
                amount: "Size",
                date: "Date",
                min_amount: "Min size",
                max_amount: "Max size",
                start_date: "Start date",
                end_date: "End date",
                date_range: "Date range",
                sort_by: "Sort by",
                currency: "Currency",
                min: "Min",
                max: "Max",
                newest_first: "Newest first",
                oldest_first: "Oldest first",
                amount_high_to_low: "Amount high to low",
                amount_low_to_high: "Amount low to high",
                search_user: "Search user",
                user_email: "Enter the user email",
                clear_filters: "Clear filters",
                download_excel: "Download excel"
            },
            added_users: "Added {{new}} users",
            added_repeated_users: "{{repeated}} users are repeated, adding {{new}} users",
            added_invalid_users: "{{invalid}} users dont exist or haven't completed KYC",
            added_user: "Added user: {{user}}",
            updated_user: "Updated user {{user}}",
            deleted_user: "Deleted user: {{user}}",
            deleted_all_users: "Deleted all users",
            no_users: "Add recipients to see them here"
        },
        payrolls_summary: {
            num_users: "Number of users",
            total_amount: "Total amount",
            min_amount: "Minimum amount",
            max_amount: "Maximum amount",
            average_amount: "Average amount",
            current_balance: "Current balance",
            balance_after_transaction: "Balance after transaction",
        },
        payrolls_file_upload: {
            title: "Load users from file",
            description: "Please use the template and enter the users to transfer",
            drop_here: "Drop file here",
            download_template: "Download template",
            download_template_description: "Use this template to fill the users",
            upload_file: "Upload file",
            upload_file_description: "Accepted files: .csv, .txt, .xlsx",
            success: "File processed, adding users",
            close: "Close",
            errors: {
                invalid_file_type: "Invalid file type",
                invalid_file: "Invalid or empty file",
                parse_error: "Error processing the file",
                check_error: "Error checking the users"
            }
        },
        payrolls_edit_user_modal: {
            title: "Edit user",
            email_label: "Enter the recipient email",
            email_placeholder: "Enter email",
            submit: "Save",
            delete: "Delete",
            cancel: "Cancel"
        },
        payrolls_errors: {
            cannot_send_to_self: "You can't send a transfer to yourself",
            duplicate_user: "User is already in the list",
            invalid_username: "The user does not exist or is not KYC approved",
            error_creating_user_list: "Error creating user list",
        },
        mass_transfers_modal: {
            title: "Mass Transfers",
            select_transfer: "Select a transfer to see the detail"
        },
        create_user_list_modal: {
            title: "Save recipient list",
            name_label: "List name",
            name_placeholder: "Enter list name",
            description_label: "Description",
            description_placeholder: "Enter a description",
            num_users: "Users",
            preferred_amount_label: "Preferred amount",
            preferred_amount_placeholder: "Enter preferred amount",
            preferred_currency_label: "Preferred currency",
            preferred_currency_placeholder: "Select currency",
            submit: "Create",
            cancel: "Cancel"
        },
        send_mass_transfer_modal: {
            title: "Send mass transfer",
            name_label: "Display name",
            name_placeholder: "Enter display name",
            submit: "Send transfer",
            cancel: "Cancel"
        },
        edit_user_list_modal: {
            title: "Update recipient list",
            name_label: "List name",
            name_placeholder: "Enter list name",
            description_label: "Description",
            description_placeholder: "Enter a description",
            num_users: "Users",
            new_email_placeholder: "Add recipient email",
            invalid_username: "Invalid user",
            preferred_amount_label: "Preferred amount",
            preferred_amount_placeholder: "Enter preferred amount",
            preferred_currency_label: "Preferred currency",
            preferred_currency_placeholder: "Select currency",
            success: "User list updated",
            error_updating_user_list: "Error updating user list",
            submit: "Save",
            cancel: "Cancel"
        },
        check_username_input: {
            placeholder: "Enter username",
            valid_username: "Valid user",
            invalid_username: "Invalid user",
            cannot_send_to_self: "You can't send a transfer to yourself",
            repeated_username: "User is repeated"
        },
        creating_mass_transfer: "Creating mass transfer...",
        list_name: "List name",
        list_name_required: "List name is required",
        add_recipient: "Add recipient",
        remove_recipient: "Remove recipient",
        fill_all_required_fields: "Please fill all required fields",
        mass_transfer_created_successfully: "Mass transfer created successfully",
        error_creating_mass_transfer: "Error creating mass transfer",
        recent_mass_transfers: "History",
        loading: "Loading...",
        no_transfers_yet: "No transfers yet",
        recipients_count: "{{count}} recipients",
        status_options: {
            pending: "Pending",
            processing: "Processing",
            completed: "Completed",
            failed: "Failed"
        },
        user_list: "User list",
        create_new_list: "Create new list",
        select_existing_list: "Select existing list",
        transfer_details: "Transfer details",
        remove: "Remove",
        select_or_create_list: "Please select or create a user list",
        fill_all_emails: "Please fill all emails",
        amount_required: "Amount is required",
        no_user_lists: "No user lists yet",
        user_list_modal: {
            title: "Add recipient list",
            name_label: "Name",
            description_label: "Description",
            search_placeholder: "Search user",
            no_users: "No users found",
            total_users: "Total",
            preferred_amount: "Preferred amount",
            select_button: "Add",
            close_button: "Close"
        },
        mass_transfer_item: {
            recipients_count: "{{count}} recipients",
            total_label: "Total",
            amount_label: "Amount",
            status: {
              pending: "Pending",
              processing: "Processing",
              completed: "Completed",
              failed: "Failed",
              cancelled: "Cancelled"
            }
        },
        need_help: "Need help?",
        refer: "Invite a friend",
        referral_section: {
            title: "Invite Your Friends",
            description: "Share your invitation code with friends so they can join.",
            copy_code: "Copy referral link"
        },
        conection_slow: "Your connection seems slow, click here to try again or contact support if the problem persists",
    },
    pt: {
        any_question: "Conheça-nos",
        one_card_all_crypto: "Todo o seu mundo cripto, em um só cartão",
        nemo_card_top: "Transforme seus ativos digitais em experiências reais e faça suas compras serem momentos únicos.",
        nemo_card_mid: "Pague em qualquer estabelecimento, saque dinheiro em caixas eletrônicos e gerencie seu dinheiro como nunca antes.",
        nemo_card_mid_list_item_1: "Use em milhares de lojas físicas e online.",
        nemo_card_mid_list_item_2: "Saques em caixas eletrônicos de forma rápida e segura.",
        nemo_card_mid_list_item_3: "Sem papelada, sem complicações. Em minutos, sua solicitação estará em andamento!",
        nemo_card_mid_end: "Receba com segurança em nossos escritórios ou na porta da sua casa.",
        amount_too_high: "Valor muito alto",
        no_results_found: "Nenhum resultado encontrado",
        enter_amount: "Digite o valor",
        amount_exceeds_balance: "O valor excede o saldo disponível",
        type_search: "Digite para buscar...",
        create_payment: "Adicionar",
        amount_too_low: "Valor muito baixo",
        country_not_supported: "País não admitido",
        country_missing: "País não selecionado",
        feetoe_note: "Nota: Os bancos podem cobrar taxas adicionais por transferências.",
        fee_breakdown: "Detalhamento de taxas",
        amount_to_receive: "Valor a receber",
        fee_deducted: "Taxa deduzida",
        fee_calculation: "Taxa",
        max_withdrawal: "Saque máximo",
        min_withdrawal: "Saque mínimo",
        invalid_value: "Valor inválido",
        limits_note: "Nota: As taxas estão incluídas nos limites.",
        rates_are_referential: "*As taxas mostradas são apenas referenciais",
        input_number_to_see_rates: "Insira um valor para ver a taxa de câmbio",
        please_try_again: "Por favor, tente novamente",
        asset: "Ativo",
        pan: "PAN",
        cvc: "CVC",
        occupation: "Ocupação",
        annualSalary: "Salário anual",
        accountPurpose: "Finalidade da conta",
        validating_kyc_data_title: "Estamos validando suas informações",
        validating_kyc_data_text: `Em alguns momentos você poderá entrar no mundo ${localConfig.brand}`,
        not_available: "Indisponível",
        login_or_register_to_enter_raffle: "Faça login ou crie uma conta para participar",
        success_registration_raffle: "Você já está participando!",
        we_are: "Estamos em",
        maintenance: "manutenção",
        icon: brazilcircle,
        apple_download_badge: appstorees,
        google_download_badge: googleplayes,
        continue: "Continuar",
        description: "Descrição",
        login: "Entrar",
        logout: "Sair",
        email: "E-mail",
        password: "Senha",
        email_placeholder: "Digite seu e-mail",
        password_placeholder: "Digite sua senha",
        dont_have_account: "Não tem uma conta?",
        forgot_password: "Esqueceu sua senha?",
        invalid_login: "Credenciais inválidas",
        reset_psw: "Devido à atualização, é necessário redefinir sua senha",
        confirm_password: "Confirmar senha",
        confirm_password_placeholder: "Digite sua senha novamente",
        register: "Criar conta",
        register_success: "Conta criada com sucesso",
        register_fail: "Falha ao criar conta",
        already_have_account: "Já tem uma conta?",
        password_mismatch: "As senhas não coincidem",
        password_too_short: "Pelo menos 8 caracteres",
        password_needs_uppercase: "Pelo menos uma letra maiúscula",
        password_needs_lowercase: "Pelo menos uma letra minúscula",
        password_needs_number: "Pelo menos um número",
        password_needs_special: "Pelo menos um caractere especial",
        hinting_regex_error: "A senha não atende aos requisitos mínimos",
        complete_the_captcha: "Complete o CAPTCHA",
        register_failed: "Falha ao criar conta, tente novamente",
        balance_navbar: "Saldo total",
        terms_text1: "Li e concordo com os",
        terms_text2: "da Nemo Latam.",
        terms_and_conditions: "Termos e Condições",
        card_term1_texta: "Aceito o",
        card_term1_textb: "Consentimento de Assinatura Eletrônica",
        card_term2_texta: "Aceito os",
        card_term2_textb: "Termos do Cartão Nemo",
        card_term2_textc: ", e a",
        card_term2_textd: "Política de Privacidade da Nemo",
        card_term3_texta: "Certifico que as informações fornecidas são precisas e que seguirei todas as regras e requisitos relacionados ao meu Cartão de Gastos Nemo.",
        card_term4_texta: "Reconheço que solicitar o Cartão de Gastos Nemo não constitui uma solicitação não autorizada.",
        privacy_policy: "Política de Privacidade",
        data_processing_policy: "Política de Tratamento de Dados",
        declaration_text1: "Li e confirmo a",
        goods_declaration: "Declaração de Origem de Fundos.",
        authorization_text1: "Li e confirmo a",
        data_authorization: "Autorização para o tratamento",
        authorization_text2: "dos meus dados pessoais.",
        confirm_email: "Confirmar e-mail",
        email_code: "Código de confirmação",
        email_code_text: "Enviamos um e-mail com um código, por favor digite-o abaixo.",
        confirm: "Confirmar",
        cancel: "Cancelar",
        code_placeholder: "Digite seu código de confirmação",
        resent_code: "Código reenviado",
        email_confirmed: "E-mail verificado. Faça login para verificar sua identidade",
        verify_email: "Verificar e-mail",
        back_to_login: "Voltar para login",
        resend_code: "Reenviar código",
        in: "em",
        name: "Nome",
        seconds: "segundos",
        click_to: "Clique para",
        click_here: "Clique aqui",
        incorrect_code: "Código incorreto",
        reset_password: "Redefinir senha",
        email_sent: "E-mail enviado",
        error: "Erro",
        unexpected_error: "Ocorreu um erro inesperado",
        invalid_confirmation_code: "Código de confirmação inválido",
        captcha_failed: "Falha no CAPTCHA",
        reset_continue_text: "Enviamos um e-mail com instruções para redefinir sua senha.",
        password_reset_success: "Senha redefinida com sucesso",
        new_password: "Nova senha",
        confirm_new_password: "Confirmar nova senha",
        new_password_placeholder: "Digite sua nova senha",
        new_confirm_password_placeholder: "Confirme sua nova senha",
        reset_code_expired: "Link de redefinição expirado, solicite um novo",
        reset_password_request: "Solicitar redefinição de senha",
        reset_password_request_button: "Solicitar redefinição",
        password_reset_success_text: "Senha redefinida com sucesso. Agora você pode fazer login normalmente.",
        wallet: "Carteira",
        converter: "Conversor",
        deposit: "Depositar",
        peertopeer: "Peer2peer",
        payrolls: "Transferências",
        withdrawal: "Sacar",
        deposit_noun: "Depósito",
        unknown: "Desconhecido",
        withdrawal_noun: "Saque",
        cards: "Cartões",
        profile: "Perfil",
        modal_deposit: {
          title: "Solicitação de depósito",
          info: "Você criou uma solicitação de depósito, siga os passos na nova aba para completar o processo",
          description: "Caso nenhuma aba tenha aberto, clique no link abaixo",
          link: "Clique aqui",
          button: "Ir para carteira"
        },
        modal_withdrawal: {
          title: "Solicitação de saque",
          info: "Você criou uma solicitação de saque, siga os passos na nova aba para completar o processo.",
          info_card: "Recebemos sua solicitação de saque. A confirmação pode levar até 24 horas.",
          info_crypto: "Você criou uma solicitação de saque. Aguarde a confirmação para ver seu saldo atualizado.",
          description: "Caso nenhuma aba tenha aberto, clique no link abaixo.",
          link: "Clique aqui",
          button: "Ir para carteira"
        },
        payment_account_modal: {
          title: "Criar conta de pagamento",
        },
        payment_account_info_modal: {
          title: "Informações da conta de pagamento",
        },
        active_card_modal: {
          title: "Ativar seu Cartão Nemo",
          text: "Para usar seu cartão, é necessário ativá-lo. Insira o número de rastreamento do cartão.",
          placeholder: "Insira o número de rastreamento"
        },
        ligo_card_actions: {
          active: "Para ativar seu cartão LIGO, você deve primeiro ativá-lo através do LIGO.",
          block: "Para bloquear seu cartão LIGO, entre em contato com o suporte do LIGO."
        },
        card_inswitch_request: {
          success: "Cartão virtual criado",
          error: "Erro ao solicitar cartão virtual"
        },
        card_request: {
          success: "Solicitação de cartão criada",
          error: "Erro ao solicitar cartão",
        },
        card_action_modal: {
          activate: {
            title: "Ative Seu Cartão Nemo",
            text: "É necessário ativar seu cartão antes de usá-lo.",
            success: "Cartão ativado com sucesso.",
            inswitch_error: "Não foi possível ativar o cartão.",
            ligo_error: "Para ativar seu cartão LIGO, você deve primeiro ativá-lo através do LIGO.",
          },
          blocked: {
            title: "Bloqueie Seu Cartão Nemo",
            text: "Todas as transações deste cartão serão bloqueadas.",
            success: "Cartão bloqueado com sucesso.",
            error: "Ocorreu um erro inesperado.",
            ligo_error: "Para bloquear seu cartão LIGO, entre em contato com o suporte do LIGO."
          },
          details: {
            title: "Detalhes do Cartão Nemo",
            text: "",
            success: "",
            error: ""
          },
          fund: {
            title: "Adicione Fundos ao Seu Cartão Nemo",
            text: "Para adicionar fundos, faça um saque e selecione sua conta de pagamento USD do cartão Nemo.",
            success: "",
            error: ""
          },
          pin: {
                title: "Atualizar PIN",
                text: "Digite um PIN diferente do PIN atual",
                success: "PIN atualizado com sucesso",
                error: "Erro ao atualizar o PIN",
                invalid: "PIN inválido, tente novamente",
                form: {
                  enter_pin: "Novo PIN",
                  enter_pin_placeholder: "Digite seu novo PIN",
                  confirm_pin: "Confirmar PIN",
                  confirm_pin_placeholder: "Digite o PIN novamente",
                  confirmation_code: "Código de confirmação",
                  enter_confirmation_code: "Digite o código de confirmação",
                  send_code: "Enviar código de confirmação",
                  pin_error: "Os valores não são iguais"
                }
            }
        },
        notFoundPage: {
          title: "Página não encontrada",
          subtitle: "A página solicitada não foi encontrada."
        },
        create_wallet: "Criar carteira",
        create_wallet_title: "Crie seu novo endereço para ",
        create_wallet_sub_title: "Criar endereço para a rede",
        missing_form_fields: "Campos do formulário incompletos",
        take_me_nemo: "Me leve para NEMO",
        balance: "Saldo",
        show_balance: "Mostrar saldo",
        no_balance: "Sem saldo",
        assets: "Ativos",
        total_balance: "Saldo total",
        equivalent_balance: "Saldo equivalente",
        available_balance: "Saldo disponível",
        balance_after_withdrawal: "Saldo após saque",
        small_balances: "Saldos pequenos",
        long_coin_names: {
          COP: "Peso colombiano",
          USDT: "USD Tether",
          ETH: "Ethereum",
          BTC: "Bitcoin",
          PEN: "Sol peruano",
          USD: "Dólar americano",
        },
        two_step_verification: "Verificação em duas etapas",
        first_name: "Nome",
        last_name: "Sobrenome",
        full_name: "Nome completo",
        profile_header: "Meu perfil",
        cards_header: "Seu cartão",
        peertopeer_header: "Peer to peer",
        peertopeer_title: "Troque ativos com outros usuários",
        peertopeer_send: "Enviar",
        peertopeer_back: "Voltar",
        peertopeer_publicity_title: "Troca de ativos",
        peertopeer_publicity_description: "Realize trocas de ativos de forma segura, rápida e transparente. Sem taxas!",
        peertopeer_username_placeholder: "Digite o nome de usuário",
        peertopeer_minimum_amount: "Mínimo",
        peertopeer_maximum_amount: "Máximo",
        peertopeer_send_to: "Enviando para",
        peertopeer_destination: "Destinatário",
        peertopeer_insert_username: "Digite o nome de usuário",
        peertopeer_username_success: "Usuário válido",
        peertopeer_success: "Transferência concluída",
        peertopeer_errors: {
          invalid_value: "Por favor digite apenas números",
          invalid_qr: "O código QR é inválido",
          too_much_decimals: "Você não pode exceder o máximo de casas decimais",
          value_lower_than_min: "O valor digitado é menor que o mínimo",
          value_higher_than_max: "O valor digitado excede o máximo",
          invalid_username: "O usuário não existe ou é inválido",
          cannot_send_to_self: "Você não pode enviar ativos para si mesmo",
          transfer_error: "Ocorreu um erro ao fazer a transferência",
          not_enough_balance: "Você não tem saldo suficiente para fazer a transferência",
          too_many_digits: "Não pode exceder o máximo de dígitos",
        },
        peertopeer_modal: {
          title: "Transferência concluída",
          user: "usuário",
          id: "id",
          close: "Voltar"
        },
        country: "País",
        phone: "Telefone",
        coin_price: "Preço da moeda",
        cost_price: "Preço de custo",
        amount: "Quantidade",
        limits: "Limites",
        limit_overflow: "O valor deve estar entre os limites",
        limit_overflow_disclaimer: "O valor deve estar entre os limites, caso contrário não será creditado",
        min_amount: "Quantidade mínima",
        max_amount: "Quantidade máxima",
        recieve_amount: "Quantidade a receber",
        fee: "Taxa",
        min_fee: "Taxa mínima",
        actions: "Ações",
        h_change: "Variação 24h",
        coin: "Moeda",
        search_coin: "Buscar moeda",
        card: "Cartão",
        bank: "Banco",
        cash: "Dinheiro",
        date: "Data",
        select_coin: "Selecione uma moeda",
        select_blockchain: "Selecione uma rede",
        blockchain: "Rede",
        blockchain_currency: "Rede",
        select_method: "Selecione um método",
        select_option: "Selecione uma opção",
        no_option: "Nenhuma opção disponível",
        select_payment_account: "Selecione uma conta de pagamento",
        bank_name: "Nome do banco",
        account_type: "Tipo de conta",
        account_type_checking: "Conta corrente",
        account_type_savings: "Conta poupança",
        account_number: "Número da conta",
        phone_number: "Número de celular",
        firstname: "Nome",
        lastname: "Sobrenome",
        document_number: "Número do documento",
        document_type: "Tipo de documento",
        nationalId: "RG",
        foreignerId: "RNE",
        passport: "Passaporte",
        chanceryId: "Carteira Diplomática",
        ruc: "CNPJ",
        display_name: "Apelido da conta",
        display_name_description: "Digite o nome com o qual deseja identificar esta conta",
        address: "Endereço",
        city: "Cidade",
        installments: "Parcelas",
        send: "Enviar",
        insert: "Digite seu ",
        success_copy_address: "Endereço copiado com sucesso",
        error_copy_address: "Ocorreu um erro ao copiar o endereço",
        copied_to_clipboard: "Copiado para a área de transferência",
        error_copy_clipboard: "Erro ao copiar para a área de transferência",
        payment_account_created: "Nova conta de pagamento criada",
        balance_history: "Saldo / Histórico",
        selling: "Você dá",
        getting: "Você recebe",
        convert: "Converter",
        exceeds_balance_more_than_max: "A quantidade selecionada excede o saldo atual ou o tamanho máximo da ordem para o ativo a dar",
        less_than_min: "A quantidade selecionada é menor que o mínimo aceitável para o ativo a dar",
        selected_amount_not_available: "A quantidade selecionada não está disponível, entre em contato com o suporte",
        movements: "Movimentações",
        order_executed: "Ordem executada com sucesso",
        traded: "Você trocou",
        for: "por",
        invalid_address: "Conta de pagamento inválida",
        payouts_freezed: "Os pagamentos estão congelados devido a uma redefinição de senha.",
        next: "Próximo",
        previous: "Anterior",
        nomovements: "Você ainda não tem histórico de transações",
        nolists: "Você ainda não tem listas de usuários",
        nomasstransfers: "Você ainda não tem transferências em massa",
        status_mapping: {
          pending: "Pendente",
          to_be_sent: "Para enviar",
          done: "Concluído",
          canceled: "Cancelado",
          cancelled: "Cancelado",
          failed: "Falhou",
          processing: "Processando",
          completed: "Concluído",
          unknown: "Desconhecido",
          wait_confirmation: "Confirmando",
          reverted: "Revertido",
          verifying: "Verificando",
        },
        statuses: "Status",
        available: "Disponível",
        trade_history: "Histórico",
        gave_got: "Você deu | Você recebeu",
        gave: "Você deu",
        got: "Você recebeu",
        price: "Preço",
        no_balance_conv: "Saldo da moeda base é 0",
        fee_apply_t: "Taxa aplicada de",
        fee_equivalent_t: "equivalente a",
        hello_nickname: "Bem-vindo,",
        birthday: "Data de nascimento",
        old_password: "Senha atual",
        old_password_placeholder: "Digite sua senha atual",
        change_password_label: "Senha",
        change_password: "Alterar senha",
        change_password_button: "Alterar",
        enable_two_fa: "Habilitar 2FA",
        addresses_label: "Meus endereços",
        add_address_button: "Adicionar endereço",
        request_virtual_card: "Solicitar cartão virtual",
        request_card: "Solicitar cartão",
        wrong_old_password: "Senha atual incorreta",
        security: "Segurança",
        addresses: "Endereços",
        two_fa: "Autenticação em dois fatores",
        enable: "Habilitar",
        disable: "Desabilitar",
        two_fa_off: "2FA desativado",
        two_fa_on: "2FA ativado",
        tfa_explanation: "Escanear código QR com algum aplicativo autenticador",
        scan_qr: "Escanear",
        stop_scan_qr: "Cancelar",
        scan_qr_modal: {
          title: "Escanear código QR",
          error_camera: "Ocorreu um erro, verifique as permissões da sua câmera",
          error_scanner: "Erro de javascript",
          close: "Cancelar"
        },
        back: "Voltar",
        submit: "Enviar",
        ready: "Pronto",
        put_authenticator_otp: "Digite o OTP do autenticador",
        tfa_otp_input_placeholder: "XXXXXX",
        otp_failed: "Código incorreto",
        tfa_setup_successful: "Autenticação em dois fatores configurada com sucesso",
        tfa_disable_successful: "Autenticação em dois fatores removida com sucesso",
        card_coin: "Ativo para saques",
        card_balance: "Saldo",
        card_options_title: "Ações",
        card_asset_info_modal: {
          title: "Ativo para saques",
          text: "O ativo selecionado será usado para saques ou compras com seu cartão Nemo, que está em USD. Atualmente, apenas USDT é suportado, mas mais ativos estarão disponíveis em breve. A conversão é feita internamente ao preço de mercado.",
        },
        card_pan: "Número do cartão",
        card_expiry: "Data de expiração",
        card_cvv: "CVV",
        card_data_disclaimer: "Por motivos de segurança, os dados do cartão (número e CVV) são gerados dinamicamente e podem mudar cada vez que você visualizar os detalhes.",
        inswitch: "Cartão Virtual",
        ligo: "Cartão Ligo",
        rain: "Cartão Nemo",
        activate_card: "Ativar",
        block_card: "Bloquear",
        show_details: "Mostrar detalhes",
        add_funds: "Adicionar fundos",
        update_pin: "Atualizar PIN",
        inswitch_disclaimer: `O titular da conta bancária deve ser o mesmo titular da conta ${localConfig.brand.toUpperCase()}. É responsabilidade do usuário garantir que o nome e número de identificação da conta bancária correspondam aos dados registrados em sua conta ${localConfig.brand.toUpperCase()}.`,
        website_under_maintenance: "Plataforma em manutenção, voltaremos em alguns instantes.",
        nemocard: "Cartão Nemo",
        active: "Ativo",
        inactive: "Inativo",
        blocked: "Bloqueado",
        suspended: "Suspenso",
        assigned: "Não Ativo",
        unassigned: "Não Atribuído",
        error_refresh_page: "Tente novamente em alguns minutos",
        delete: "Excluir",
        bank_transfer: "Transferência bancária",
        account_credit: "Crédito em conta",
        cci_number: "CCI",
        title: {
          default: "Compre e venda criptomoedas | NEMO Latam",
          "": "Carteira e Saldo",
          converter: "Converter Moedas",
          peertopeer: "Troca de Ativos",
          payrolls: "Pague funcionários em cripto ou fiat",
          deposit: "Deposite Cripto e FIAT",
          withdraw: "Saque Cripto e FIAT",
          profile: "Perfil e Configurações",
          cards: "Cartões Nemo",
          kyc: "Verifique sua identidade",
          login: "Faça login para começar",
          register: "Crie uma conta",
          "confirm-register": "Verifique seu e-mail",
          "reset-password": "Redefina sua senha",
          support: "Suporte",
          maintenance: "Site em manutenção",
          "*": "Não encontrado",
        },
        converter_errors: {
          invalid_value: "Porités apenas números",
          value_lower_than_min: "O valor digitado é menor que o mínimo",
          value_higher_than_max: "O valor digitado excede o tamanho máximo da ordem para o ativo a dar",
          value_higher_than_balance: "O valor digitado excede o saldo disponível",
        },
        try_later_or_contact_support: "Ocorreu um erro, tente novamente mais tarde ou entre em contato com o suporte",
        account_block: "Conta bloqueada, entre em contato com o suporte",
        other: "Outro",
        withdraw: "Sacar",
        masked_pan: "Número do cartão",
        type: "Tipo",
        physical: "Físico",
        brand: "Bandeira",
        mastercard: "Mastercard",
        expiry_mm_yyyy: "Data de expiração",
        visa: "Visa",
        virtual: "Cartão virtual",
        nemo_card_request: "Solicite seu Cartão Nemo agora!",
        nemo_card_request_info: "Leve suas criptomoedas para o mundo real",
        nemo_card_question_1: "Como obter?",
        nemo_card_answer_1_a: "Método de entrega: Retire pessoalmente.",
        nemo_card_answer_1_b: "Endereço de retirada: Av. Santa Cruz 198, San Isidro, Lima",
        nemo_card_answer_1_c: "Cartão virtual: Solicite através da plataforma.",
        nemo_card_answer_1_d: "Cartão físico: Em breve!, este serviço será lançado em breve.",
        nemo_card_question_2: "Principais características:",
        nemo_card_answer_2_a: "Bandeira: Visa, aceita em milhões de estabelecimentos em todo o mundo.",
        nemo_card_answer_2_b: "Benefícios: Agilidade, conveniência e controle total sobre seus fundos.",
        nemo_card_answer_2_c: "Bandeira: Mastercard, aceita em milhões de estabelecimentos em todo o mundo.",
        nemo_card_call_to_action: "Solicite o seu hoje e eleve suas transações ao próximo nível!",
        nemo_card_details_warning: "Por motivos de segurança, os dados do cartão (número e CVV) são gerados dinamicamente e podem mudar cada vez que você visualizar os detalhes.",
        wallet_history_item: {
          Withdrawal: "Saque",
          Deposit: "Depósito",
          original_label: "Original",
          fee_label: "Taxa",
          total_label: "Total"
        },
        card_delivery: "Entrega do cartão",
        delivery_method: "Método de entrega",
        pick_up: "Retirar pessoalmente",
        delivery_address: "Endereço de entrega",
        nemo_address: "Av. Santa Cruz 198, San Isidro, Lima",
        nemo_office_address: localConfig.countryCode === "PE" ? "Av. Santa Cruz 198, San Isidro, Lima" : "Calle 6 Sur #43A-100, Medellín, Colombia",
        user_address: {
          title: "Adicionar endereço",
          search_address_label: "Buscar endereço",
          search_address_placeholder: "Digite seu endereço",
          street_label: "Rua",
          street_placeholder: "Digite sua rua",
          city_label: "Cidade",
          city_placeholder: "Digite sua cidade",
          state_label: "Estado",
          state_placeholder: "Digite seu estado",
          zip_code_label: "CEP",
          zip_code_placeholder: "Digite seu CEP",
          country_label: "País",
          country_placeholder: "Digite seu país",
          submit: "Adicionar endereço",
          address_added: "Endereço adicionado com sucesso",
          unexpected_error: "Ocorreu um erro inesperado",
          too_many_addresses: "Você atingiu o limite máximo de endereços permitidos",
        },
        card_request_form: {
          request_sent: "Solicitação enviada",
          request_sent_text: "Você está a poucos passos de ter seu Cartão Nemo!",
          virtual_card: "Cartão virtual",
          virtual_card_description: "Seu cartão aparecerá aqui quando for aprovado",
          info: "Sua solicitação de cartão será revisada por nossa equipe. Você pode escolher retirá-lo ou tê-lo entregue em seu endereço",
          title: "Criar solicitação de cartão",
          phone_number: "Número de telefone",
          phone_code: "Código",
          phone_number_placeholder: "Digite seu número de telefone",
          user_address: "Digite seu endereço fiscal",
          select_address: "Selecionar endereço de entrega",
          select_card_type: "Selecionar tipo de cartão",
          select_type: "Selecionar tipo de entrega",
          monthly_volume: "Volume mensal esperado",
          monthly_volume_placeholder: "Digite um valor em dólares",
          physical: "Físico",
          virtual: "Virtual",
          pickup: "Retirar no escritório",
          delivery: "Entrega em domicílio",
          submit: "Enviar",
          success: "Solicitação de cartão criada com sucesso",
          error: "Ocorreu um erro inesperado ao criar a solicitação de cartão",
          created: "Aguardando aprovação",
          cancel_request: "Cancelar solicitação",
          disclaimer: "Você receberá um e-mail com as instruções para retirar seu cartão",
          declined: "Solicitação recusada"
        },
        card_request_cancel: {
          title: "Cancelar solicitação de cartão",
          description: "Por favor confirme que deseja cancelar sua solicitação de cartão",
          action: "Confirmar"
        },
        months: {
          1: "Jan",
          2: "Fev",
          3: "Mar",
          4: "Abr",
          5: "Mai",
          6: "Jun",
          7: "Jul",
          8: "Ago",
          9: "Set",
          10: "Out",
          11: "Nov",
          12: "Dez"
        },
        support: "Suporte",
        tickets: "Tickets",
        subject: "Assunto",
        upload_image: "Enviar imagem",
        optional: "Opcional",
        sent: "Enviar",
        support_ticket_creation_success: "Ticket criado com sucesso",
        support_ticket_creation_error: "Não foi possível criar o ticket",
        support_ticket_size_error: "Não foi possível carregar a imagem",
        ticket_new: "Novo",
        ticket_open: "Em espera",
        ticket_pending: "Responder",
        ticket_solved: "Fechado",
        close: "Fechar",
        support_ticket_created_modal: {
          title: "Ticket criado com sucesso",
          info: "Seu ticket foi criado com sucesso. Em alguns segundos, você poderá vê-lo na outra seção.",
        },
        faq: "Perguntas frequentes",
        faq_search_error: "Busca vazia",
        search: "Buscar",
        no_data_search: "Nenhum resultado encontrado",
        no_tickets: "Nenhum ticket encontrado",
        create_support_ticket: "Criar um ticket de suporte",
        payrolls_main_title: "Enviar transferência em massa",
        payrolls_user_lists: "Listas de destinatários",
        payrolls_configure: "Configurar transferência",
        payrolls_send: "Enviar transferência",
        payrolls_save_list: "Salvar lista",
        payrolls_clean_list: "Limpar lista",
        payrolls_recipients: "Destinatários",
        payrolls_valid_username: "Usuário válido",
        payrolls_user_list_created: "Lista de usuários criada",
        payrolls_transfer_success: "Transferência pendente de aprovação",
        payrolls_transfer_error: "Erro ao realizar a transferência",
        payrolls_transfer_name: "Transferência",
        payrolls_form: {
          amount_placeholder: "Digite a quantidade a enviar",
          new_email_placeholder: "Adicionar e-mail do destinatário",
          search_user: "Buscar usuário",
          sort_invalid: "Inválidos",
          sort_amount: "Valor",
          sort_alpha: "A-Z",
          delete_user_modal: {
            title: "Excluir usuário",
            text: "Por favor confirme que deseja excluir o usuário:",
            confirm: "Excluir",
            cancel: "Cancelar"
          },
          delete_all_users_modal: {
            title: "Limpar lista",
            text: "Por favor confirme que deseja limpar a lista de usuários",
            confirm: "Limpar",
            cancel: "Cancelar"
          },
          delete_list_modal: {
            title: "Excluir lista de destinatários",
            text: "Por favor confirme que deseja excluir a lista de destinatários",
            confirm: "Excluir",
            cancel: "Cancelar",
            success: "Lista de destinatários excluída",
            error: "Erro ao excluir a lista de destinatários"
          },
          history_filters: {
            amount: "Valor",
            date: "Data",
            min_amount: "Valor mínimo",
            max_amount: "Valor máximo",
            start_date: "Data de início",
            end_date: "Data de término",
            date_range: "Período",
            sort_by: "Ordenar por",
            currency: "Moeda",
            min: "Mín",
            max: "Máx",
            newest_first: "Mais recentes",
            oldest_first: "Mais antigos",
            amount_high_to_low: "Valor alto a baixo",
            amount_low_to_high: "Valor baixo a alto",
            search_user: "Buscar usuário",
            user_email: "Digite o e-mail do usuário",
            clear_filters: "Limpar filtros",
            download_excel: "Ba-hub excel"
          },
          added_users: "{{new}} usuários adicionados",
          added_repeated_users: "{{repeated}} usuários repetidos, {{new}} usuários adicionados",
          added_invalid_users: "{{invalid}} usuários não existem ou não completaram o KYC",
          added_user: "Usuário adicionado: {{user}}",
          updated_user: "Usuário atualizado {{user}}",
          deleted_user: "Usuário excluído: {{user}}",
          deleted_all_users: "Todos os usuários excluídos",
          no_users: "Adicione destinatários para vê-los aqui"
        },
        payrolls_summary: {
          num_users: "Número de usuários",
          total_amount: "Valor total",
          min_amount: "Valor mínimo",
          max_amount: "Valor máximo",
          average_amount: "Valor médio",
          current_balance: "Saldo atual",
          balance_after_transaction: "Saldo após a transação",
        },
        payrolls_file_upload: {
          title: "Carregar usuários do arquivo",
          description: "Por favor use o modelo e insira os usuários para transferir",
          drop_here: "Arraste e solte o arquivo aqui",
          download_template: "Baixar modelo",
          download_template_description: "Use este modelo para preencher os usuários",
          upload_file: "Enviar arquivo",
          upload_file_description: "Arquivos aceitos: .csv, .txt, .xlsx",
          success: "Arquivo processado, adicionando usuários",
          close: "Fechar",
          errors: {
            invalid_file_type: "Tipo de arquivo inválido",
            invalid_file: "Arquivo inválido ou vazio",
            parse_error: "Erro ao processar o arquivo",
            check_error: "Erro ao verificar os usuários"
          }
        },
        payrolls_edit_user_modal: {
          title: "Editar usuário",
          email_label: "Digite o e-mail do destinatário",
          email_placeholder: "Digite o e-mail",
          submit: "Salvar",
          delete: "Excluir",
          cancel: "Cancelar"
        },
        payrolls_errors: {
          cannot_send_to_self: "Você não pode enviar para si mesmo",
          duplicate_user: "O usuário já foi adicionado",
          invalid_username: "O usuário não existe ou não completou o KYC",
          error_creating_user_list: "Erro ao criar lista de usuários",
        },
        mass_transfers_modal: {
          title: "Transferências em massa",
          select_transfer: "Selecione uma transferência para ver o detalhe"
        },
        create_user_list_modal: {
          title: "Salvar lista de destinatários",
          name_label: "Nome da lista",
          name_placeholder: "Digite o nome da lista",
          description_label: "Descrição",
          description_placeholder: "Digite uma descrição",
          num_users: "Usuários",
          preferred_amount_label: "Valor preferido",
          preferred_amount_placeholder: "Digite o valor preferido",
          preferred_currency_label: "Moeda preferida",
          preferred_currency_placeholder: "Selecione a moeda",
          submit: "Criar",
          cancel: "Cancelar"
        },
        send_mass_transfer_modal: {
          title: "Enviar transferência",
          name_label: "Nome da transferência",
          name_placeholder: "Digite o nome da transferência",
          submit: "Enviar transferência",
          cancel: "Cancelar"
        },
        edit_user_list_modal: {
          title: "Editar lista de destinatários",
          name_label: "Nome da lista",
          name_placeholder: "Digite o nome da lista",
          description_label: "Descrição",
          description_placeholder: "Digite uma descrição",
          num_users: "Usuários",
          new_email_placeholder: "Adicionar e-mail do destinatário",
          invalid_username: "Usuário inválido",
          preferred_amount_label: "Valor preferido",
          preferred_amount_placeholder: "Digite o valor preferido",
          preferred_currency_label: "Moeda preferida",
          preferred_currency_placeholder: "Selecione a moeda",
          success: "Lista de usuários atualizada com sucesso",
          error_updating_user_list: "Erro ao atualizar lista de usuários",
          submit: "Salvar",
          cancel: "Cancelar"
        },
        check_username_input: {
          placeholder: "Digite o usuário",
          valid_username: "Usuário válido",
          invalid_username: "Usuário inválido",
          cannot_send_to_self: "Você não pode enviar para si mesmo",
          repeated_username: "Usuário repetido"
        },
        creating_mass_transfer: "Criando transferência em massa...",
        list_name: "Nome da lista",
        list_name_required: "O nome da lista é obrigatório",
        add_recipient: "Adicionar destinatário",
        remove_recipient: "Remover destinatário",
        fill_all_required_fields: "Por favor preencha todos os campos obrigatórios",
        mass_transfer_created_successfully: "Transferência em massa criada com sucesso",
        error_creating_mass_transfer: "Erro ao criar transferência em massa",
        recent_mass_transfers: "Histórico",
        loading: "Carregando...",
        no_transfers_yet: "Ainda não há transferências em massa",
        recipients_count: "{{count}} destinatários",
        status_options: {
          pending: "Pendente",
          processing: "Processando",
          completed: "Concluído",
          failed: "Falhou"
        },
        user_list: "Lista de usuários",
        create_new_list: "Criar nova lista",
        select_existing_list: "Selecionar lista existente",
        transfer_details: "Detalhes da transferência",
        remove: "Remover",
        select_or_create_list: "Por favor selecione ou crie uma lista de usuários",
        fill_all_emails: "Por favor preencha todos os e-mails",
        amount_required: "O valor é obrigatório",
        no_user_lists: "Ainda não há listas de usuários",
        user_list_modal: {
          title: "Adicionar lista de destinatários",
          name_label: "Nome",
          description_label: "Descrição",
          search_placeholder: "Buscar usuário",
          no_users: "Nenhum usuário encontrado",
          total_users: "Total",
          preferred_amount: "Valor preferido",
          select_button: "Adicionar",
          close_button: "Fechar"
        },
        mass_transfer_item: {
          recipients_count: "{{count}} destinatários",
          total_label: "Total",
          amount_label: "Valor",
          status: {
            pending: "Pendente",
            processing: "Processando",
            completed: "Concluído",
            failed: "Falhou",
            cancelled: "Cancelado"
          }
        },
        need_help: "Precisa de ajuda?",
        refer: "Convide um amigo",
        referral_section: {
          title: "Convide seus amigos",
          description: "Compartilhe seu código de convite com amigos para que eles se cadastrem.",
          copy_code: "Copiar link de convite"
        },
        conection_slow: "Conexão lenta, clique aqui para tentar novamente ou contate o suporte se o problema persistir"
      }
    }

export default common
